window.CabaneCategoryNavigation = {
  "groups": {
    "catalogue": {
      "label": "Tous les univers",
      "parent": null,
      "items": [
        {
          "label": "Trottinettes",
          "group": "scooter",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/s2s-trottinette-freestyle-la-cabane-de-la-glisse-chrome-noir--scoot-2-street-scooter.jpg?v=1687189988&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Trottinettes+Freestyles+Completes%22+OR+tag%3A%22Trottinettes+trampoline%22+OR+tag%3A%22Trottinettes+enfant%22&navigation=scooter"
        },
        {
          "label": "Skateboards",
          "group": "skate",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Tony-Hawk-SS-180Complete-Badge-Logo-multicolor-7.75-IN-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1701531550&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Skateboards+complets%22+OR+tag%3A%22Longboards%22+OR+tag%3A%22Cruiser+Surfskate%22+OR+%28title%3Asurfskate*+OR+%28title%3Atruck*+AND+title%3Asurfskate*%29+OR+tag%3A%22Roues+skateboard%22+OR+tag%3A%22Grips+skateboard%22+OR+%28tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22%29+OR+tag%3A%22Accessoires+skateboard%22%29+OR+%28tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22%29+OR+tag%3A%22Fingerskates%22&navigation=skate"
        },
        {
          "label": "Rollers",
          "group": "roller",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/rollers-skates-equinox-roces-la-cabane-de-la-glisse.jpg?v=1702728466&width=120",
          "available": true,
          "url": "/search?type=product&q=%28tag%3A%22Protections+enfant%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22%29+OR+tag%3A%22Rollers+en+ligne%22+OR+tag%3A%22Rollers+quad%22+OR+tag%3A%22Heelys+Chaussure+%C3%A0+Roulette%22+OR+tag%3A%22Rollers+freestyle+agressif%22+OR+tag%3A%22Rollers+3+roues%22+OR+%28tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22%29+OR+tag%3A%22Rollers+hockey%22+OR+tag%3A%22Sacs%22&navigation=roller"
        },
        {
          "label": "Hockey & patins",
          "group": "hockey",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/patin-hockey-bauer-x-lp-intermediaire-la-cabane-de-la-glisse-hockey.jpg?v=1696079696&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Patins%22+OR+tag%3A%22Crosses%22+OR+tag%3A%22Protections+Hockey+Enfants%22+OR+tag%3A%22Accessoires+hockey%22+OR+%28tag%3A%22Maillots%22+OR+tag%3A%22Pantalons+roller+hockey%22+OR+tag%3A%22Bas+hockey%22%29+OR+tag%3A%22Rollers+hockey%22&navigation=hockey"
        },
        {
          "label": "BMX",
          "group": "bmx",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Haro-Leucadia-20_-Bike-gris-BMX-freestyle-Cabane-de-la-Glisse_1.png?v=1707412193&width=120",
          "available": true,
          "url": "/collections/bmx?navigation=bmx"
        },
        {
          "label": "Protections",
          "group": "protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/casque-tsg-la-cabane-de-la-glisse-noir.png?v=1777456946&width=120",
          "available": true,
          "url": "/collections/protections?navigation=protection"
        },
        {
          "label": "Lifestyle",
          "group": "lifestyle",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/T-shirtETHICDTCCasualsuspectNoirTrottinettefreestyleCabanedelaglisse..png?v=1691421508&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22vetements%22+OR+tag%3A%22Heelys+Chaussure+%C3%A0+Roulette%22+OR+tag%3A%22Sacs%22+OR+tag%3A%22Fingerskates%22+OR+tag%3A%22Kendamas%22+OR+%28title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22%29&navigation=lifestyle"
        }
      ]
    },
    "scooter": {
      "label": "Trottinettes",
      "parent": "catalogue",
      "items": [
        {
          "label": "Pièces",
          "group": "scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Roues-Air-Neochrome-Root-Industries-Trottinette-Freestyle-Cabane-de-la-glisse.png?v=1708440712&width=120",
          "available": true,
          "url": "/collections/pieces-detachees-trottinettes-freestyle?navigation=scooter-parts"
        },
        {
          "label": "Freestyle",
          "handle": "trottinettes-freestyles-completes",
          "url": "/collections/trottinettes-freestyles-completes?navigation=scooter",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/s2s-trottinette-freestyle-la-cabane-de-la-glisse-chrome-noir--scoot-2-street-scooter.jpg?v=1687189988&width=120",
          "available": true
        },
        {
          "label": "Trampolines",
          "handle": "trottinettes-trampoline",
          "url": "/collections/trottinettes-trampoline?navigation=scooter",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/1_7259325d-3596-47bd-9f87-0821b3e5383c.png?v=1779278970&width=120",
          "available": true
        },
        {
          "label": "Enfants",
          "group": "scooter-kids",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/3WheelFoldyTealPeach_1.jpg?v=1788779595&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22groupe-core-foldy3%22+OR+tag%3A%22groupe-core-foldy%22&navigation=scooter-kids"
        },
        {
          "label": "Grandes roues",
          "group": "scooter-large",
          "image": "asset:cabane-category-9e579d9662.webp",
          "available": false,
          "url": "/pages/catalogue?rubrique=scooter-large"
        },
        {
          "label": "Goodies",
          "group": "goodies",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/KROM_POP_PINK-04-la-cabane-de-la-glisse-krom-kendamas-5.webp?v=1702054616&width=120",
          "available": true,
          "url": "/search?type=product&q=title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22&navigation=goodies"
        },
        {
          "label": "Protections",
          "group": "protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Protection-genouillere-Core-Pro-park-trottinette-skateboard-freestyle-Cabane-De-La-Glisse.png?v=1713371363&width=120",
          "available": true,
          "url": "/collections/protections?navigation=protection"
        },
        {
          "label": "Modules",
          "handle": "groupe-core-rampe",
          "url": "/collections/groupe-core-rampe?navigation=scooter",
          "image": "asset:cabane-category-7d0fc01c35.webp",
          "available": false
        },
        {
          "label": "Antivols",
          "image": "asset:cabane-category-fce698d697.webp",
          "available": false
        },
        {
          "label": "Snowscoots",
          "image": "asset:cabane-category-5ace0a869b.webp",
          "available": false
        }
      ],
      "url": "/search?type=product&q=tag%3A%22Trottinettes+Freestyles+Completes%22+OR+tag%3A%22Trottinettes+trampoline%22+OR+tag%3A%22Trottinettes+enfant%22&navigation=scooter",
      "productQuery": "tag:\"Trottinettes Freestyles Completes\" OR tag:\"Trottinettes trampoline\" OR tag:\"Trottinettes enfant\"",
      "productUrl": "/search?type=product&q=tag%3A%22Trottinettes+Freestyles+Completes%22+OR+tag%3A%22Trottinettes+trampoline%22+OR+tag%3A%22Trottinettes+enfant%22&navigation=scooter",
      "legacyProductQueries": [
        "tag:\"Pièces détachées trottinettes freestyle\" OR tag:\"Trottinettes Freestyles Completes\" OR tag:\"Trottinettes trampoline\" OR (tag:\"groupe-core-foldy3\" OR tag:\"Roulements\" OR tag:\"Packs protections enfant\") OR (title:autocollant* OR tag:\"Accessoires\" OR tag:\"Kendamas\") OR tag:\"Protections\""
      ]
    },
    "scooter-parts": {
      "label": "Pièces de trottinette",
      "parent": "scooter",
      "items": [
        {
          "label": "Roues",
          "handle": "roues-trottinettes",
          "url": "/collections/roues-trottinettes?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Roues-Air-Neochrome-Root-Industries-Trottinette-Freestyle-Cabane-de-la-glisse.png?v=1708440712&width=120",
          "available": true
        },
        {
          "label": "Guidons",
          "handle": "bars-guidons",
          "url": "/collections/bars-guidons?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/la-cabane-de-la-glisse-bar-titane-chrome-longway-kronos-tro.png?v=1705595774&width=120",
          "available": true
        },
        {
          "label": "Poignées",
          "handle": "poignees",
          "url": "/collections/poignees?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/poigneesodinoir165mmtrottinettefreestylelacabanedelaglisse.webp?v=1779551294&width=120",
          "available": true
        },
        {
          "label": "Decks",
          "handle": "decks",
          "url": "/collections/decks?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/3_c75deb7a-2676-4904-944c-2ab7bdf8d2c6.png?v=1784301942&width=120",
          "available": true
        },
        {
          "label": "Grips",
          "handle": "grips-trottinettes",
          "url": "/collections/grips-trottinettes?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Root-Donuts-Grip-Trottinette-Freestyle-_Donuts_-grip-la-cabane-de-la-glisse-multicolor-grip.png?v=1696951655&width=120",
          "available": true
        },
        {
          "label": "Fourches",
          "handle": "fourches",
          "url": "/collections/fourches?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Fourche-Merrow-V3-Noir-Ethic-SCS-Trottinette-Freestyle-Cabane-de-la-glisse.png?v=1708427123&width=120",
          "available": true
        },
        {
          "label": "Jeux de direction",
          "handle": "jeux-de-direction",
          "url": "/collections/jeux-de-direction?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/la-cabane-de-la-glisse-tilt-jeu-de-direction-jdd-forest-trottinette-freestyle.png?v=1777114559&width=120",
          "available": true
        },
        {
          "label": "Colliers de serrage",
          "handle": "colliers-de-serrages",
          "url": "/collections/colliers-de-serrages?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/collierdeserragescsomennoirlacabanedelaglissetrottinettefreestylescooter.png?v=1687154770&width=120",
          "available": true
        },
        {
          "label": "Système de compression",
          "url": "/search?type=product&q=title%3A%22kit+de+compression%22+OR+title%3A%22cale+HIC%22&navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/170_source_1765978283.jpg?v=1787921586&width=120",
          "available": true,
          "legacyQuery": "kit compression"
        },
        {
          "label": "Freins",
          "handle": "freins",
          "url": "/collections/freins?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/frein-ethic-dtc-brakeless-la-cabane-de-la-glisse-trottinette-freestyle.png?v=1693993027&width=120",
          "available": true
        },
        {
          "label": "Axes",
          "url": "/search?type=product&q=title%3Aaxe&navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/axe-spacers-ethic-dtc-deck-pandemonium-v2_1fc9e95d-2370-4f66-a53e-38a46f37f304.jpg?v=1784813011&width=120",
          "available": true,
          "legacyQuery": "axe"
        },
        {
          "label": "Roulements",
          "handle": "roulements",
          "url": "/collections/roulements?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Entretoises pour deck",
          "url": "/search?type=product&q=title%3Aentretoise+AND+title%3Adeck&navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Entretoise-pour-deck-Apex-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1703007485&width=120",
          "available": true,
          "legacyQuery": "entretoise deck"
        },
        {
          "label": "Divers",
          "handle": "autres-pieces-trottinettes",
          "url": "/collections/autres-pieces-trottinettes?navigation=scooter-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Stand-scooter-ethic-8std-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700908936&width=120",
          "available": true
        }
      ],
      "url": "/collections/pieces-detachees-trottinettes-freestyle?navigation=scooter-parts"
    },
    "scooter-kids": {
      "label": "Trottinettes enfant",
      "parent": "scooter",
      "items": [
        {
          "label": "Trottinettes",
          "handle": "groupe-core-foldy-3-roues",
          "url": "/collections/groupe-core-foldy-3-roues?navigation=scooter-kids",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/3WheelFoldyTealPeach_1.jpg?v=1788779595&width=120",
          "available": true
        },
        {
          "label": "Draisiennes",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces",
          "group": "scooter-kids-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Roues-Air-Neochrome-Root-Industries-Trottinette-Freestyle-Cabane-de-la-glisse.png?v=1708440712&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roulements%22&navigation=scooter-kids-parts"
        },
        {
          "label": "Casques",
          "handle": "casques-enfant",
          "url": "/collections/casques-enfant?navigation=scooter-kids",
          "image": "",
          "available": false
        },
        {
          "label": "Kit de protections",
          "handle": "packs-protections-enfant",
          "url": "/collections/packs-protections-enfant?navigation=scooter-kids",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true
        }
      ],
      "productQuery": "tag:\"groupe-core-foldy3\" OR tag:\"groupe-core-foldy\"",
      "productUrl": "/search?type=product&q=tag%3A%22groupe-core-foldy3%22+OR+tag%3A%22groupe-core-foldy%22&navigation=scooter-kids",
      "url": "/search?type=product&q=tag%3A%22groupe-core-foldy3%22+OR+tag%3A%22groupe-core-foldy%22&navigation=scooter-kids",
      "legacyProductQueries": [
        "tag:\"groupe-core-foldy3\" OR tag:\"Roulements\" OR tag:\"Packs protections enfant\""
      ]
    },
    "scooter-kids-parts": {
      "label": "Pièces enfant",
      "parent": "scooter-kids",
      "items": [
        {
          "label": "Roues",
          "url": "/search?type=product&q=roue%20foldy&navigation=scooter-kids-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Roulements",
          "handle": "roulements",
          "url": "/collections/roulements?navigation=scooter-kids-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Accessoires",
          "url": "/search?type=product&q=accessoire%20foldy&navigation=scooter-kids-parts",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Roulements\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roulements%22&navigation=scooter-kids-parts",
      "url": "/search?type=product&q=tag%3A%22Roulements%22&navigation=scooter-kids-parts"
    },
    "scooter-large": {
      "label": "Trottinettes grandes roues",
      "parent": "scooter",
      "items": [
        {
          "label": "Trottinettes",
          "image": "",
          "available": false
        },
        {
          "label": "Accessoires",
          "image": "",
          "available": false
        }
      ]
    },
    "goodies": {
      "label": "Goodies",
      "parent": "scooter",
      "items": [
        {
          "label": "Autocollants",
          "url": "/search?type=product&q=title%3Aautocollant*&navigation=goodies",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-sticker-icon-4cm-black-5056421905528-18815835177110.jpg?v=1788779485&width=120",
          "available": true,
          "legacyQuery": "autocollant"
        },
        {
          "label": "Divers",
          "handle": "accessoires",
          "url": "/collections/accessoires?navigation=goodies",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Stand-scooter-ethic-8std-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700908936&width=120",
          "available": true
        },
        {
          "label": "Kendama",
          "handle": "kendamas",
          "url": "/collections/kendamas?navigation=goodies",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/KROM_POP_PINK-04-la-cabane-de-la-glisse-krom-kendamas-5.webp?v=1702054616&width=120",
          "available": true
        }
      ],
      "productQuery": "title:autocollant* OR tag:\"Accessoires\" OR tag:\"Kendamas\"",
      "productUrl": "/search?type=product&q=title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22&navigation=goodies",
      "url": "/search?type=product&q=title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22&navigation=goodies"
    },
    "skate": {
      "label": "Skateboards",
      "parent": "catalogue",
      "items": [
        {
          "label": "Skateboards",
          "group": "skateboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Tony-Hawk-SS-180Complete-Badge-Logo-multicolor-7.75-IN-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1701531550&width=120",
          "available": true,
          "url": "/collections/skateboards-complets?navigation=skateboards"
        },
        {
          "label": "Longboards",
          "group": "longboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Arbor-Performance-Longboard-Complete-Photo-Axis-37_-longboard-la-cabane-de-la-glisse.png?v=1719050482&width=120",
          "available": true,
          "url": "/collections/longboard?navigation=longboards"
        },
        {
          "label": "Cruisers",
          "group": "cruisers",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Cruiser-Ocean-Pacific-Swell-Cruiser-skateboard-la-cabane-de-la-glisse_1.png?v=1702119149&width=120",
          "available": true,
          "url": "/collections/cruiser-surfskate?navigation=cruisers"
        },
        {
          "label": "Surfskates",
          "group": "surfskates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Cruiser-Ocean-Pacific-Swell-Cruiser-skateboard-la-cabane-de-la-glisse_1.png?v=1702119149&width=120",
          "available": true,
          "url": "/search?type=product&q=title%3Asurfskate*+OR+%28title%3Atruck*+AND+title%3Asurfskate*%29+OR+tag%3A%22Roues+skateboard%22+OR+tag%3A%22Grips+skateboard%22+OR+%28tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22%29+OR+tag%3A%22Accessoires+skateboard%22&navigation=surfskates"
        },
        {
          "label": "Waveboards",
          "group": "waveboards",
          "image": "",
          "available": false,
          "url": "/pages/catalogue?rubrique=waveboards"
        },
        {
          "label": "Protections",
          "group": "skate-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/casque-tsg-la-cabane-de-la-glisse-noir.png?v=1777456946&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22&navigation=skate-protection"
        },
        {
          "label": "Fingerskate",
          "handle": "fingerskates",
          "url": "/collections/fingerskates?navigation=skate",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Format_Completes_FINGER_SCOOTERS_AOSV6_BK__94650.jpg?v=1779287620&width=120",
          "available": true
        },
        {
          "label": "Snowskates",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Skateboards complets\" OR tag:\"Longboards\" OR tag:\"Cruiser Surfskate\" OR (title:surfskate* OR (title:truck* AND title:surfskate*) OR tag:\"Roues skateboard\" OR tag:\"Grips skateboard\" OR (tag:\"Roulements\" OR title:bushing* OR tag:\"Visseries skateboard\" OR tag:\"Pads\" OR tag:\"Outils skateboard\") OR tag:\"Accessoires skateboard\") OR (tag:\"Protections enfant\" OR tag:\"Casques\" OR tag:\"Packs protections\" OR tag:\"Genouillères\" OR tag:\"Coudières\" OR tag:\"Shorts\") OR tag:\"Fingerskates\"",
      "productUrl": "/search?type=product&q=tag%3A%22Skateboards+complets%22+OR+tag%3A%22Longboards%22+OR+tag%3A%22Cruiser+Surfskate%22+OR+%28title%3Asurfskate*+OR+%28title%3Atruck*+AND+title%3Asurfskate*%29+OR+tag%3A%22Roues+skateboard%22+OR+tag%3A%22Grips+skateboard%22+OR+%28tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22%29+OR+tag%3A%22Accessoires+skateboard%22%29+OR+%28tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22%29+OR+tag%3A%22Fingerskates%22&navigation=skate",
      "url": "/search?type=product&q=tag%3A%22Skateboards+complets%22+OR+tag%3A%22Longboards%22+OR+tag%3A%22Cruiser+Surfskate%22+OR+%28title%3Asurfskate*+OR+%28title%3Atruck*+AND+title%3Asurfskate*%29+OR+tag%3A%22Roues+skateboard%22+OR+tag%3A%22Grips+skateboard%22+OR+%28tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22%29+OR+tag%3A%22Accessoires+skateboard%22%29+OR+%28tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22%29+OR+tag%3A%22Fingerskates%22&navigation=skate"
    },
    "skateboards": {
      "label": "Skateboards classiques",
      "parent": "skate",
      "items": [
        {
          "label": "Complets",
          "handle": "skateboards-complets",
          "url": "/collections/skateboards-complets?navigation=skateboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Tony-Hawk-SS-180Complete-Badge-Logo-multicolor-7.75-IN-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1701531550&width=120",
          "available": true
        },
        {
          "label": "Enfants",
          "url": "/search?type=product&q=skateboard%20enfant&navigation=skateboards",
          "image": "",
          "available": false
        },
        {
          "label": "Planches",
          "handle": "planches",
          "url": "/collections/planches?navigation=skateboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/SUSHI-PAGODA-LOGO-DECK-BLACK-8.125.jpg?v=1788605113&width=120",
          "available": true
        },
        {
          "label": "Trucks",
          "handle": "trucks",
          "url": "/collections/trucks?navigation=skateboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/la-cabane-de-la-glisse-skateboard-trucks-noir-5-2.png?v=1703330446&width=120",
          "available": true
        },
        {
          "label": "Roues",
          "handle": "roues",
          "url": "/collections/roues?navigation=skateboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Sushi-Wheels-Pagoda-Team-V2-Black-53mm-freestyle-la-cabane-de-la-glisse_1.png?v=1703326426&width=120",
          "available": true
        },
        {
          "label": "Grip",
          "handle": "grip-skateboard",
          "url": "/collections/grip-skateboard?navigation=skateboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Jessup-Original-Grip-la-cabane-de-la-glisse-noir-grip-trottinette-freestyle-scooter.png?v=1697032347&width=120",
          "available": true
        },
        {
          "label": "Pièces",
          "group": "skate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22groupe-core-wax%22+OR+tag%3A%22Outils+skateboard%22&navigation=skate-parts"
        },
        {
          "label": "Accessoires skate",
          "handle": "accessoires-skateboard",
          "url": "/collections/accessoires-skateboard?navigation=skateboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-epic-skate-wax-green-1.jpg?v=1788779273&width=120",
          "available": true
        },
        {
          "label": "Rampes",
          "handle": "groupe-core-rampe",
          "url": "/collections/groupe-core-rampe?navigation=skateboards",
          "image": "",
          "available": false
        },
        {
          "label": "Sacs",
          "handle": "sacs",
          "url": "/collections/sacs?navigation=skateboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-pro-helmet-backpack.jpg?v=1787908551&width=120",
          "available": true
        }
      ],
      "url": "/collections/skateboards-complets?navigation=skateboards"
    },
    "skate-parts": {
      "label": "Pièces de skateboard",
      "parent": "skateboards",
      "items": [
        {
          "label": "Roulements",
          "handle": "roulements",
          "url": "/collections/roulements?navigation=skate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Pièces trucks",
          "url": "/search?type=product&q=title%3Abushing*&navigation=skate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/sushibearingsbushings125.1563188251_800x_f7562bb5-75f5-412a-9784-4b5d74e0816b.jpg?v=1788605114&width=120",
          "available": true,
          "legacyQuery": "bushing"
        },
        {
          "label": "Vis & écrous",
          "handle": "visseries-skateboard",
          "url": "/collections/visseries-skateboard?navigation=skate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Sushi-Visserie-cabane-de-la-glisse.png?v=1703588277&width=120",
          "available": true
        },
        {
          "label": "Risers",
          "handle": "pads",
          "url": "/collections/pads?navigation=skate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Riser-sushi-pagoda-noir-skateboard-Cabane-De-La-Glisse.png?v=1713367307&width=120",
          "available": true
        },
        {
          "label": "Wax skate",
          "handle": "groupe-core-wax",
          "url": "/collections/groupe-core-wax?navigation=skate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-epic-skate-wax-teal-5060719853118-29072656892093.jpg?v=1788779273&width=120",
          "available": true
        },
        {
          "label": "Rails",
          "url": "/search?type=product&q=rails%20skateboard&navigation=skate-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Entretien",
          "handle": "outils-skateboard",
          "url": "/collections/outils-skateboard?navigation=skate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/ethic-dtc-holy-tool.jpg?v=1788604934&width=120",
          "available": true
        }
      ],
      "productQuery": "tag:\"Roulements\" OR title:bushing* OR tag:\"Visseries skateboard\" OR tag:\"Pads\" OR tag:\"groupe-core-wax\" OR tag:\"Outils skateboard\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22groupe-core-wax%22+OR+tag%3A%22Outils+skateboard%22&navigation=skate-parts",
      "url": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22groupe-core-wax%22+OR+tag%3A%22Outils+skateboard%22&navigation=skate-parts"
    },
    "longboards": {
      "label": "Longboards",
      "parent": "skate",
      "items": [
        {
          "label": "Complets",
          "handle": "longboard",
          "url": "/collections/longboard?navigation=longboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Arbor-Performance-Longboard-Complete-Photo-Axis-37_-longboard-la-cabane-de-la-glisse.png?v=1719050482&width=120",
          "available": true
        },
        {
          "label": "Planches",
          "url": "/search?type=product&q=deck%20longboard&navigation=longboards",
          "image": "",
          "available": false
        },
        {
          "label": "Trucks",
          "url": "/search?type=product&q=trucks%20longboard&navigation=longboards",
          "image": "",
          "available": false
        },
        {
          "label": "Roues",
          "url": "/search?type=product&q=title%3Aroues*+AND+title%3Alongboard*&navigation=longboards",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Ram-Wheels-Marina-Blue-70mm78a-freestyle-la-cabane-de-la-glisse_ebd048b2-a55a-4527-9d36-c98079cdcb69.png?v=1703324487&width=120",
          "available": true,
          "legacyQuery": "roues longboard"
        },
        {
          "label": "Grip",
          "url": "/search?type=product&q=grip%20longboard&navigation=longboards",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces",
          "group": "longboard-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=longboard-parts"
        },
        {
          "label": "Goodies",
          "group": "goodies",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/KROM_POP_PINK-04-la-cabane-de-la-glisse-krom-kendamas-5.webp?v=1702054616&width=120",
          "available": true,
          "url": "/search?type=product&q=title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22&navigation=goodies"
        }
      ],
      "url": "/collections/longboard?navigation=longboards"
    },
    "longboard-parts": {
      "label": "Pièces de longboard",
      "parent": "longboards",
      "items": [
        {
          "label": "Roulements",
          "handle": "roulements",
          "url": "/collections/roulements?navigation=longboard-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Pièces trucks",
          "url": "/search?type=product&q=title%3Abushing*&navigation=longboard-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/sushibearingsbushings125.1563188251_800x_f7562bb5-75f5-412a-9784-4b5d74e0816b.jpg?v=1788605114&width=120",
          "available": true,
          "legacyQuery": "bushing"
        },
        {
          "label": "Vis & écrous",
          "handle": "visseries-skateboard",
          "url": "/collections/visseries-skateboard?navigation=longboard-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Sushi-Visserie-cabane-de-la-glisse.png?v=1703588277&width=120",
          "available": true
        },
        {
          "label": "Risers",
          "handle": "pads",
          "url": "/collections/pads?navigation=longboard-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Riser-sushi-pagoda-noir-skateboard-Cabane-De-La-Glisse.png?v=1713367307&width=120",
          "available": true
        },
        {
          "label": "Entretien",
          "handle": "outils-skateboard",
          "url": "/collections/outils-skateboard?navigation=longboard-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/ethic-dtc-holy-tool.jpg?v=1788604934&width=120",
          "available": true
        }
      ],
      "productQuery": "tag:\"Roulements\" OR title:bushing* OR tag:\"Visseries skateboard\" OR tag:\"Pads\" OR tag:\"Outils skateboard\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=longboard-parts",
      "url": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=longboard-parts"
    },
    "cruisers": {
      "label": "Cruisers",
      "parent": "skate",
      "items": [
        {
          "label": "Complets",
          "handle": "cruiser-surfskate",
          "url": "/collections/cruiser-surfskate?navigation=cruisers",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Cruiser-Ocean-Pacific-Swell-Cruiser-skateboard-la-cabane-de-la-glisse_1.png?v=1702119149&width=120",
          "available": true
        },
        {
          "label": "Enfants",
          "url": "/search?type=product&q=cruiser%20enfant&navigation=cruisers",
          "image": "",
          "available": false
        },
        {
          "label": "Plastique / Penny",
          "url": "/search?type=product&q=penny&navigation=cruisers",
          "image": "",
          "available": false
        },
        {
          "label": "Planches",
          "url": "/search?type=product&q=planche%20cruiser&navigation=cruisers",
          "image": "",
          "available": false
        },
        {
          "label": "Trucks",
          "handle": "trucks",
          "url": "/collections/trucks?navigation=cruisers",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/la-cabane-de-la-glisse-skateboard-trucks-noir-5-2.png?v=1703330446&width=120",
          "available": true
        },
        {
          "label": "Roues",
          "handle": "roues",
          "url": "/collections/roues?navigation=cruisers",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Sushi-Wheels-Pagoda-Team-V2-Black-53mm-freestyle-la-cabane-de-la-glisse_1.png?v=1703326426&width=120",
          "available": true
        },
        {
          "label": "Grip",
          "handle": "grip-skateboard",
          "url": "/collections/grip-skateboard?navigation=cruisers",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Jessup-Original-Grip-la-cabane-de-la-glisse-noir-grip-trottinette-freestyle-scooter.png?v=1697032347&width=120",
          "available": true
        },
        {
          "label": "Pièces",
          "group": "cruiser-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=cruiser-parts"
        },
        {
          "label": "Accessoires",
          "handle": "accessoires-skateboard",
          "url": "/collections/accessoires-skateboard?navigation=cruisers",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-epic-skate-wax-green-1.jpg?v=1788779273&width=120",
          "available": true
        }
      ],
      "url": "/collections/cruiser-surfskate?navigation=cruisers"
    },
    "cruiser-parts": {
      "label": "Pièces de cruiser",
      "parent": "cruisers",
      "items": [
        {
          "label": "Roulements",
          "handle": "roulements",
          "url": "/collections/roulements?navigation=cruiser-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Pièces trucks",
          "url": "/search?type=product&q=title%3Abushing*&navigation=cruiser-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/sushibearingsbushings125.1563188251_800x_f7562bb5-75f5-412a-9784-4b5d74e0816b.jpg?v=1788605114&width=120",
          "available": true,
          "legacyQuery": "bushing"
        },
        {
          "label": "Vis & écrous",
          "handle": "visseries-skateboard",
          "url": "/collections/visseries-skateboard?navigation=cruiser-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Sushi-Visserie-cabane-de-la-glisse.png?v=1703588277&width=120",
          "available": true
        },
        {
          "label": "Risers",
          "handle": "pads",
          "url": "/collections/pads?navigation=cruiser-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Riser-sushi-pagoda-noir-skateboard-Cabane-De-La-Glisse.png?v=1713367307&width=120",
          "available": true
        },
        {
          "label": "Entretien",
          "handle": "outils-skateboard",
          "url": "/collections/outils-skateboard?navigation=cruiser-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/ethic-dtc-holy-tool.jpg?v=1788604934&width=120",
          "available": true
        }
      ],
      "productQuery": "tag:\"Roulements\" OR title:bushing* OR tag:\"Visseries skateboard\" OR tag:\"Pads\" OR tag:\"Outils skateboard\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=cruiser-parts",
      "url": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=cruiser-parts"
    },
    "surfskates": {
      "label": "Surfskates",
      "parent": "skate",
      "items": [
        {
          "label": "Complets",
          "url": "/search?type=product&q=title%3Asurfskate*&navigation=surfskates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/CARVER_C5_HOLLOW_COAL_BLACK.png?v=1788614858&width=120",
          "available": true,
          "legacyQuery": "surfskate"
        },
        {
          "label": "Trucks",
          "url": "/search?type=product&q=title%3Atruck*+AND+title%3Asurfskate*&navigation=surfskates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/CARVER_C5_HOLLOW_COAL_BLACK.png?v=1788614858&width=120",
          "available": true,
          "legacyQuery": "truck surfskate"
        },
        {
          "label": "Roues",
          "handle": "roues",
          "url": "/collections/roues?navigation=surfskates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Sushi-Wheels-Pagoda-Team-V2-Black-53mm-freestyle-la-cabane-de-la-glisse_1.png?v=1703326426&width=120",
          "available": true
        },
        {
          "label": "Grip",
          "handle": "grip-skateboard",
          "url": "/collections/grip-skateboard?navigation=surfskates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Jessup-Original-Grip-la-cabane-de-la-glisse-noir-grip-trottinette-freestyle-scooter.png?v=1697032347&width=120",
          "available": true
        },
        {
          "label": "Pièces",
          "group": "surfskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=surfskate-parts"
        },
        {
          "label": "Accessoires",
          "handle": "accessoires-skateboard",
          "url": "/collections/accessoires-skateboard?navigation=surfskates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-epic-skate-wax-green-1.jpg?v=1788779273&width=120",
          "available": true
        }
      ],
      "productQuery": "title:surfskate* OR (title:truck* AND title:surfskate*) OR tag:\"Roues skateboard\" OR tag:\"Grips skateboard\" OR (tag:\"Roulements\" OR title:bushing* OR tag:\"Visseries skateboard\" OR tag:\"Pads\" OR tag:\"Outils skateboard\") OR tag:\"Accessoires skateboard\"",
      "productUrl": "/search?type=product&q=title%3Asurfskate*+OR+%28title%3Atruck*+AND+title%3Asurfskate*%29+OR+tag%3A%22Roues+skateboard%22+OR+tag%3A%22Grips+skateboard%22+OR+%28tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22%29+OR+tag%3A%22Accessoires+skateboard%22&navigation=surfskates",
      "url": "/search?type=product&q=title%3Asurfskate*+OR+%28title%3Atruck*+AND+title%3Asurfskate*%29+OR+tag%3A%22Roues+skateboard%22+OR+tag%3A%22Grips+skateboard%22+OR+%28tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22%29+OR+tag%3A%22Accessoires+skateboard%22&navigation=surfskates"
    },
    "surfskate-parts": {
      "label": "Pièces de surfskate",
      "parent": "surfskates",
      "items": [
        {
          "label": "Roulements",
          "handle": "roulements",
          "url": "/collections/roulements?navigation=surfskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Pièces trucks",
          "url": "/search?type=product&q=title%3Abushing*&navigation=surfskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/sushibearingsbushings125.1563188251_800x_f7562bb5-75f5-412a-9784-4b5d74e0816b.jpg?v=1788605114&width=120",
          "available": true,
          "legacyQuery": "bushing"
        },
        {
          "label": "Vis & écrous",
          "handle": "visseries-skateboard",
          "url": "/collections/visseries-skateboard?navigation=surfskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Sushi-Visserie-cabane-de-la-glisse.png?v=1703588277&width=120",
          "available": true
        },
        {
          "label": "Risers",
          "handle": "pads",
          "url": "/collections/pads?navigation=surfskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Riser-sushi-pagoda-noir-skateboard-Cabane-De-La-Glisse.png?v=1713367307&width=120",
          "available": true
        },
        {
          "label": "Entretien",
          "handle": "outils-skateboard",
          "url": "/collections/outils-skateboard?navigation=surfskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/ethic-dtc-holy-tool.jpg?v=1788604934&width=120",
          "available": true
        }
      ],
      "productQuery": "tag:\"Roulements\" OR title:bushing* OR tag:\"Visseries skateboard\" OR tag:\"Pads\" OR tag:\"Outils skateboard\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=surfskate-parts",
      "url": "/search?type=product&q=tag%3A%22Roulements%22+OR+title%3Abushing*+OR+tag%3A%22Visseries+skateboard%22+OR+tag%3A%22Pads%22+OR+tag%3A%22Outils+skateboard%22&navigation=surfskate-parts"
    },
    "waveboards": {
      "label": "Waveboards",
      "parent": "skate",
      "items": [
        {
          "label": "Complets",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces",
          "image": "",
          "available": false
        }
      ]
    },
    "roller": {
      "label": "Rollers",
      "parent": "catalogue",
      "items": [
        {
          "label": "Protections",
          "group": "roller-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22&navigation=roller-protection"
        },
        {
          "label": "Rollers en ligne",
          "group": "roller-inline",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/rollers-skates-equinox-roces-la-cabane-de-la-glisse.jpg?v=1702728466&width=120",
          "available": true,
          "url": "/collections/rollers-en-ligne?navigation=roller-inline"
        },
        {
          "label": "Patins à roulettes",
          "group": "roller-quad",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Rollersquadimpalalacabanedelaglisse5.png?v=1710844807&width=120",
          "available": true,
          "url": "/collections/rollers-quad?navigation=roller-quad"
        },
        {
          "label": "Chaussures à roulettes",
          "handle": "heelys-chaussure-a-roulette",
          "url": "/collections/heelys-chaussure-a-roulette?navigation=roller",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Heelys-pro20-noir-heelys-Cabane-De-La-Glisse.png?v=1713359545&width=120",
          "available": true
        },
        {
          "label": "Agressif",
          "group": "roller-aggressive",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/roces-patins-a-roues-alignees-m12-ufs-la-cabane-de-la-glisse-noir-roces-rollers-aggressif-freestyle-street.jpg?v=1696074167&width=120",
          "available": true,
          "url": "/collections/rollers-freestyle-agressif?navigation=roller-aggressive"
        },
        {
          "label": "Freeskate",
          "group": "roller-freeskate",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/rollers-skates-equinox-roces-la-cabane-de-la-glisse.jpg?v=1702728466&width=120",
          "available": true,
          "url": "/collections/rollers-3-roues?navigation=roller-freeskate"
        },
        {
          "label": "Vitesse",
          "group": "roller-speed",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-speed"
        },
        {
          "label": "Marathon",
          "url": "/search?type=product&q=roller%20marathon&navigation=roller",
          "image": "",
          "available": false
        },
        {
          "label": "Roller tout-terrain",
          "group": "roller-offroad",
          "image": "",
          "available": false,
          "url": "/pages/catalogue?rubrique=roller-offroad"
        },
        {
          "label": "Roller hockey",
          "group": "roller-hockey",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Roller-Hockey-rs-bauer-Noir-Roller-Hockey-Cabane-De-La-Glisse.png?v=1712826508&width=120",
          "available": true,
          "url": "/collections/rollers-hockey?navigation=roller-hockey"
        },
        {
          "label": "Roller skis",
          "image": "",
          "available": false
        },
        {
          "label": "Sacs",
          "handle": "sacs",
          "url": "/collections/sacs?navigation=roller",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-pro-helmet-backpack.jpg?v=1787908551&width=120",
          "available": true
        }
      ],
      "productQuery": "(tag:\"Protections enfant\" OR tag:\"Packs protections\" OR tag:\"Coudières\" OR tag:\"Shorts\") OR tag:\"Rollers en ligne\" OR tag:\"Rollers quad\" OR tag:\"Heelys Chaussure à Roulette\" OR tag:\"Rollers freestyle agressif\" OR tag:\"Rollers 3 roues\" OR (tag:\"Roues rollers\" OR tag:\"Roulements\" OR tag:\"Visseries Rollers\") OR tag:\"Rollers hockey\" OR tag:\"Sacs\"",
      "productUrl": "/search?type=product&q=%28tag%3A%22Protections+enfant%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22%29+OR+tag%3A%22Rollers+en+ligne%22+OR+tag%3A%22Rollers+quad%22+OR+tag%3A%22Heelys+Chaussure+%C3%A0+Roulette%22+OR+tag%3A%22Rollers+freestyle+agressif%22+OR+tag%3A%22Rollers+3+roues%22+OR+%28tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22%29+OR+tag%3A%22Rollers+hockey%22+OR+tag%3A%22Sacs%22&navigation=roller",
      "url": "/search?type=product&q=%28tag%3A%22Protections+enfant%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22%29+OR+tag%3A%22Rollers+en+ligne%22+OR+tag%3A%22Rollers+quad%22+OR+tag%3A%22Heelys+Chaussure+%C3%A0+Roulette%22+OR+tag%3A%22Rollers+freestyle+agressif%22+OR+tag%3A%22Rollers+3+roues%22+OR+%28tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22%29+OR+tag%3A%22Rollers+hockey%22+OR+tag%3A%22Sacs%22&navigation=roller"
    },
    "roller-inline": {
      "label": "Rollers en ligne",
      "parent": "roller",
      "items": [
        {
          "label": "Enfants",
          "handle": "rollers-enfant",
          "url": "/collections/rollers-enfant?navigation=roller-inline",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/ROCESJokey3.0-bleu-Roller-Cabane-de-la-Glisse.png?v=1711638143&width=120",
          "available": true
        },
        {
          "label": "Hommes",
          "url": "/search?type=product&q=roller%20homme&navigation=roller-inline",
          "image": "",
          "available": false
        },
        {
          "label": "Femmes",
          "url": "/search?type=product&q=roller%20femme&navigation=roller-inline",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces",
          "group": "roller-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true,
          "url": "/search?type=product&q=%28tag%3A%22Roues+rollers%22+AND+title%3Aroue*%29+OR+%28title%3Afrein*+AND+title%3Aroller*%29+OR+%28tag%3A%22Roulements%22+AND+NOT+title%3A%2212+STD%22%29+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-parts"
        },
        {
          "label": "Divers",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-inline",
          "image": "",
          "available": false
        }
      ],
      "url": "/collections/rollers-en-ligne?navigation=roller-inline"
    },
    "roller-parts": {
      "label": "Pièces de rollers",
      "parent": "roller-inline",
      "items": [
        {
          "label": "Roues",
          "handle": "roues-rollers",
          "url": "/collections/roues-rollers?navigation=roller-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true
        },
        {
          "label": "Freins",
          "url": "/search?type=product&q=title%3Afrein*+AND+title%3Aroller*&navigation=roller-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/fila-2-0-inline-skate-brake-pad-r9.webp?v=1788605175&width=120",
          "available": true,
          "legacyQuery": "frein roller"
        },
        {
          "label": "Roulements",
          "handle": "roulements-2",
          "url": "/collections/roulements-2?navigation=roller-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Entretoises",
          "url": "/search?type=product&q=entretoise%20roller&navigation=roller-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Axes",
          "handle": "visseries-rollers",
          "url": "/collections/visseries-rollers?navigation=roller-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Toestop-Bolt-Small-34IN-Trottinette-Freestyle-trottinette-freestyle-cabane-de-la-glisse_1.png?v=1703777851&width=120",
          "available": true
        },
        {
          "label": "Boucles",
          "url": "/search?type=product&q=boucle%20roller&navigation=roller-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Entretien",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-parts",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "(tag:\"Roues rollers\" AND title:roue*) OR (title:frein* AND title:roller*) OR (tag:\"Roulements\" AND NOT title:\"12 STD\") OR tag:\"Visseries Rollers\"",
      "productUrl": "/search?type=product&q=%28tag%3A%22Roues+rollers%22+AND+title%3Aroue*%29+OR+%28title%3Afrein*+AND+title%3Aroller*%29+OR+%28tag%3A%22Roulements%22+AND+NOT+title%3A%2212+STD%22%29+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-parts",
      "url": "/search?type=product&q=%28tag%3A%22Roues+rollers%22+AND+title%3Aroue*%29+OR+%28title%3Afrein*+AND+title%3Aroller*%29+OR+%28tag%3A%22Roulements%22+AND+NOT+title%3A%2212+STD%22%29+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-parts",
      "legacyProductQueries": [
        "tag:\"Roues rollers\" OR (title:frein* AND title:roller*) OR tag:\"Roulements\" OR tag:\"Visseries Rollers\""
      ]
    },
    "roller-quad": {
      "label": "Patins à roulettes",
      "parent": "roller",
      "items": [
        {
          "label": "Adultes",
          "handle": "rollers-quad",
          "url": "/collections/rollers-quad?navigation=roller-quad",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Rollersquadimpalalacabanedelaglisse5.png?v=1710844807&width=120",
          "available": true
        },
        {
          "label": "Enfants",
          "url": "/search?type=product&q=quad%20enfant&navigation=roller-quad",
          "image": "",
          "available": false
        },
        {
          "label": "Derby",
          "handle": "rollers-derby",
          "url": "/collections/rollers-derby?navigation=roller-quad",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces",
          "group": "roller-quad-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true,
          "url": "/search?type=product&q=%28title%3Aroue*+AND+title%3Aquad*%29+OR+%28title%3Afrein*+AND+title%3Aquad*%29+OR+tag%3A%22Roulements%22&navigation=roller-quad-parts"
        },
        {
          "label": "Divers",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-quad",
          "image": "",
          "available": false
        }
      ],
      "url": "/collections/rollers-quad?navigation=roller-quad"
    },
    "roller-quad-parts": {
      "label": "Pièces de roller quad",
      "parent": "roller-quad",
      "items": [
        {
          "label": "Roues",
          "url": "/search?type=product&q=title%3Aroue*+AND+title%3Aquad*&navigation=roller-quad-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/230d1168-5230-4f9a-aee0-c83c5c4b1d7a.jpg?v=1788605114&width=120",
          "available": true,
          "legacyQuery": "roue quad"
        },
        {
          "label": "Frein quad",
          "url": "/search?type=product&q=title%3Afrein*+AND+title%3Aquad*&navigation=roller-quad-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Frein-Rookie-All-Star-Noir-roller-freestyle-la-cabane-de-la-glisse.png?v=1703068744&width=120",
          "available": true,
          "legacyQuery": "frein quad"
        },
        {
          "label": "Roulements",
          "handle": "roulements-2",
          "url": "/collections/roulements-2?navigation=roller-quad-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Entretien",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-quad-parts",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "(title:roue* AND title:quad*) OR (title:frein* AND title:quad*) OR tag:\"Roulements\"",
      "productUrl": "/search?type=product&q=%28title%3Aroue*+AND+title%3Aquad*%29+OR+%28title%3Afrein*+AND+title%3Aquad*%29+OR+tag%3A%22Roulements%22&navigation=roller-quad-parts",
      "url": "/search?type=product&q=%28title%3Aroue*+AND+title%3Aquad*%29+OR+%28title%3Afrein*+AND+title%3Aquad*%29+OR+tag%3A%22Roulements%22&navigation=roller-quad-parts"
    },
    "roller-aggressive": {
      "label": "Agressif",
      "parent": "roller",
      "items": [
        {
          "label": "Rollers",
          "handle": "rollers-freestyle-agressif",
          "url": "/collections/rollers-freestyle-agressif?navigation=roller-aggressive",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/roces-patins-a-roues-alignees-m12-ufs-la-cabane-de-la-glisse-noir-roces-rollers-aggressif-freestyle-street.jpg?v=1696074167&width=120",
          "available": true
        },
        {
          "label": "Pièces",
          "group": "roller-aggressive-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22groupe-core-wax%22&navigation=roller-aggressive-parts"
        },
        {
          "label": "Divers",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-aggressive",
          "image": "",
          "available": false
        },
        {
          "label": "Rampes",
          "handle": "groupe-core-rampe",
          "url": "/collections/groupe-core-rampe?navigation=roller-aggressive",
          "image": "",
          "available": false
        }
      ],
      "url": "/collections/rollers-freestyle-agressif?navigation=roller-aggressive"
    },
    "roller-aggressive-parts": {
      "label": "Pièces · Agressif",
      "parent": "roller-aggressive",
      "items": [
        {
          "label": "Platines",
          "handle": "platines",
          "url": "/collections/platines?navigation=roller-aggressive-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Roues",
          "handle": "roues-rollers",
          "url": "/collections/roues-rollers?navigation=roller-aggressive-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true
        },
        {
          "label": "Roulements",
          "handle": "roulements-2",
          "url": "/collections/roulements-2?navigation=roller-aggressive-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Grindplates",
          "image": "",
          "available": false
        },
        {
          "label": "Chaussons",
          "url": "/search?type=product&q=chausson%20roller&navigation=roller-aggressive-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Cire skate",
          "handle": "groupe-core-wax",
          "url": "/collections/groupe-core-wax?navigation=roller-aggressive-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-epic-skate-wax-teal-5060719853118-29072656892093.jpg?v=1788779273&width=120",
          "available": true
        },
        {
          "label": "Entretien",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-aggressive-parts",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Roues rollers\" OR tag:\"Roulements\" OR tag:\"groupe-core-wax\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22groupe-core-wax%22&navigation=roller-aggressive-parts",
      "url": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22groupe-core-wax%22&navigation=roller-aggressive-parts"
    },
    "roller-freeskate": {
      "label": "Freeskate",
      "parent": "roller",
      "items": [
        {
          "label": "Rollers",
          "handle": "rollers-3-roues",
          "url": "/collections/rollers-3-roues?navigation=roller-freeskate",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/rollers-skates-equinox-roces-la-cabane-de-la-glisse.jpg?v=1702728466&width=120",
          "available": true
        },
        {
          "label": "Pièces",
          "group": "roller-freeskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true,
          "url": "/search?type=product&q=%28tag%3A%22Roues+rollers%22+AND+title%3Aroue*%29+OR+%28title%3Afrein*+AND+title%3Aroller*%29+OR+%28tag%3A%22Roulements%22+AND+NOT+title%3A%2212+STD%22%29+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-freeskate-parts"
        },
        {
          "label": "Divers",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-freeskate",
          "image": "",
          "available": false
        }
      ],
      "url": "/collections/rollers-3-roues?navigation=roller-freeskate"
    },
    "roller-freeskate-parts": {
      "label": "Pièces · Freeskate",
      "parent": "roller-freeskate",
      "items": [
        {
          "label": "Platines",
          "handle": "platines",
          "url": "/collections/platines?navigation=roller-freeskate-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Roues",
          "handle": "roues-rollers",
          "url": "/collections/roues-rollers?navigation=roller-freeskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true
        },
        {
          "label": "Freins",
          "url": "/search?type=product&q=title%3Afrein*+AND+title%3Aroller*&navigation=roller-freeskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/fila-2-0-inline-skate-brake-pad-r9.webp?v=1788605175&width=120",
          "available": true,
          "legacyQuery": "frein roller"
        },
        {
          "label": "Roulements",
          "handle": "roulements-2",
          "url": "/collections/roulements-2?navigation=roller-freeskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Axes",
          "handle": "visseries-rollers",
          "url": "/collections/visseries-rollers?navigation=roller-freeskate-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Toestop-Bolt-Small-34IN-Trottinette-Freestyle-trottinette-freestyle-cabane-de-la-glisse_1.png?v=1703777851&width=120",
          "available": true
        },
        {
          "label": "Chaussons",
          "url": "/search?type=product&q=chausson%20roller&navigation=roller-freeskate-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Entretien",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-freeskate-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Boucles",
          "url": "/search?type=product&q=boucle%20roller&navigation=roller-freeskate-parts",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "(tag:\"Roues rollers\" AND title:roue*) OR (title:frein* AND title:roller*) OR (tag:\"Roulements\" AND NOT title:\"12 STD\") OR tag:\"Visseries Rollers\"",
      "productUrl": "/search?type=product&q=%28tag%3A%22Roues+rollers%22+AND+title%3Aroue*%29+OR+%28title%3Afrein*+AND+title%3Aroller*%29+OR+%28tag%3A%22Roulements%22+AND+NOT+title%3A%2212+STD%22%29+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-freeskate-parts",
      "url": "/search?type=product&q=%28tag%3A%22Roues+rollers%22+AND+title%3Aroue*%29+OR+%28title%3Afrein*+AND+title%3Aroller*%29+OR+%28tag%3A%22Roulements%22+AND+NOT+title%3A%2212+STD%22%29+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-freeskate-parts"
    },
    "roller-speed": {
      "label": "Vitesse",
      "parent": "roller",
      "items": [
        {
          "label": "Rollers",
          "handle": "rollers-vitesse-course",
          "url": "/collections/rollers-vitesse-course?navigation=roller-speed",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces",
          "group": "roller-speed-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-speed-parts"
        },
        {
          "label": "Semelles",
          "image": "",
          "available": false
        },
        {
          "label": "Divers",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-speed",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Roues rollers\" OR tag:\"Roulements\" OR tag:\"Visseries Rollers\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-speed",
      "url": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-speed"
    },
    "roller-speed-parts": {
      "label": "Pièces · Vitesse",
      "parent": "roller-speed",
      "items": [
        {
          "label": "Roues",
          "handle": "roues-rollers",
          "url": "/collections/roues-rollers?navigation=roller-speed-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true
        },
        {
          "label": "Roulements",
          "handle": "roulements-2",
          "url": "/collections/roulements-2?navigation=roller-speed-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Axes",
          "handle": "visseries-rollers",
          "url": "/collections/visseries-rollers?navigation=roller-speed-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Toestop-Bolt-Small-34IN-Trottinette-Freestyle-trottinette-freestyle-cabane-de-la-glisse_1.png?v=1703777851&width=120",
          "available": true
        },
        {
          "label": "Entretien",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-speed-parts",
          "image": "",
          "available": false
        },
        {
          "label": "Boucles",
          "url": "/search?type=product&q=boucle%20roller&navigation=roller-speed-parts",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Roues rollers\" OR tag:\"Roulements\" OR tag:\"Visseries Rollers\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-speed-parts",
      "url": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22+OR+tag%3A%22Visseries+Rollers%22&navigation=roller-speed-parts"
    },
    "roller-offroad": {
      "label": "Roller tout-terrain",
      "parent": "roller",
      "items": [
        {
          "label": "Rollers",
          "url": "/search?type=product&q=roller%20tout%20terrain&navigation=roller-offroad",
          "image": "",
          "available": false
        },
        {
          "label": "Accessoires",
          "image": "",
          "available": false
        }
      ]
    },
    "roller-hockey": {
      "label": "Roller hockey",
      "parent": "roller",
      "items": [
        {
          "label": "Rollers",
          "handle": "rollers-hockey",
          "url": "/collections/rollers-hockey?navigation=roller-hockey",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Roller-Hockey-rs-bauer-Noir-Roller-Hockey-Cabane-De-La-Glisse.png?v=1712826508&width=120",
          "available": true
        },
        {
          "label": "Crosses",
          "handle": "crosses",
          "url": "/collections/crosses?navigation=roller-hockey",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/La-cabane-de-la-glisse-hockey-sur-glace-bauer-crosse-nexus-2022La-cabane-de-la-glisse-hockey-sur-glace-bauer-crosse-nexus-2022.jpg?v=1707394624&width=120",
          "available": true
        },
        {
          "label": "Balles et palets",
          "handle": "palets-balles",
          "url": "/collections/palets-balles?navigation=roller-hockey",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/hockey-palet-Reebook-Noir-Hockey-la-cabane-de-la-glisse.png?v=1699611266&width=120",
          "available": true
        },
        {
          "label": "Pièces",
          "group": "roller-hockey-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22&navigation=roller-hockey-parts"
        },
        {
          "label": "Divers",
          "handle": "accessoires-hockey",
          "url": "/collections/accessoires-hockey?navigation=roller-hockey",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/902040-1_d06f3b93-45d0-4417-8579-b79a811494e5.png?v=1788605271&width=120",
          "available": true
        },
        {
          "label": "Protections",
          "group": "hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Casque-Hockey-Bauer-IMS5-noir-hockey-la-cabane-de-la-glisse.png?v=1717147413&width=120",
          "available": true,
          "url": "/collections/protections-hockey-protections?navigation=hockey-protection"
        }
      ],
      "url": "/collections/rollers-hockey?navigation=roller-hockey"
    },
    "roller-protection": {
      "label": "Protections roller",
      "parent": "roller",
      "items": [
        {
          "label": "Enfants",
          "group": "protection-kids",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true,
          "url": "/collections/protections-enfant?navigation=protection-kids"
        },
        {
          "label": "Casques",
          "handle": "casques-rollers",
          "url": "/collections/casques-rollers?navigation=roller-protection",
          "image": "",
          "available": false
        },
        {
          "label": "Kit",
          "handle": "packs-protections",
          "url": "/collections/packs-protections?navigation=roller-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true
        },
        {
          "label": "Protège-poignets",
          "handle": "proteges-poignets",
          "url": "/collections/proteges-poignets?navigation=roller-protection",
          "image": "",
          "available": false
        },
        {
          "label": "Genouillères",
          "handle": "genouilleres-rollers",
          "url": "/collections/genouilleres-rollers?navigation=roller-protection",
          "image": "",
          "available": false
        },
        {
          "label": "Coudières",
          "handle": "coudieres",
          "url": "/collections/coudieres?navigation=roller-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Pack-genouillere-coudiere-187-killer-pads-x-Independent-noir-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700835185&width=120",
          "available": true
        },
        {
          "label": "Shorts de protection",
          "handle": "shorts",
          "url": "/collections/shorts?navigation=roller-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/CORE-Impact-Stealth-Short-protection-trottinette-freestyle-cabane-de-la-glisse.png?v=1703760807&width=120",
          "available": true
        },
        {
          "label": "Derby",
          "url": "/search?type=product&q=protection%20derby&navigation=roller-protection",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Protections enfant\" OR tag:\"Packs protections\" OR tag:\"Coudières\" OR tag:\"Shorts\"",
      "productUrl": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22&navigation=roller-protection",
      "url": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22&navigation=roller-protection"
    },
    "hockey": {
      "label": "Hockey & patins",
      "parent": "catalogue",
      "items": [
        {
          "label": "Patins à glace",
          "group": "ice-skates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/patin-hockey-bauer-x-lp-intermediaire-la-cabane-de-la-glisse-hockey.jpg?v=1696079696&width=120",
          "available": true,
          "url": "/collections/patins?navigation=ice-skates"
        },
        {
          "label": "Crosses",
          "group": "hockey-sticks",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/La-cabane-de-la-glisse-hockey-sur-glace-bauer-crosse-nexus-2022La-cabane-de-la-glisse-hockey-sur-glace-bauer-crosse-nexus-2022.jpg?v=1707394624&width=120",
          "available": true,
          "url": "/collections/crosses?navigation=hockey-sticks"
        },
        {
          "label": "Protections",
          "group": "hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Casque-Hockey-Bauer-IMS5-noir-hockey-la-cabane-de-la-glisse.png?v=1717147413&width=120",
          "available": true,
          "url": "/collections/protections-hockey-protections?navigation=hockey-protection"
        },
        {
          "label": "Accessoires",
          "group": "hockey-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/hockey-palet-Reebook-Noir-Hockey-la-cabane-de-la-glisse.png?v=1699611266&width=120",
          "available": true,
          "url": "/collections/accessoires-hockey?navigation=hockey-accessories"
        },
        {
          "label": "Textile",
          "group": "hockey-clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Flex-Practice-Jersey-Sr-Rouge-freestyle-Cabane-de-la-Glisse_2.png?v=1707990598&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Maillots%22+OR+tag%3A%22Pantalons+roller+hockey%22+OR+tag%3A%22Bas+hockey%22&navigation=hockey-clothing"
        },
        {
          "label": "Gardien",
          "handle": "gardien",
          "url": "/collections/gardien?navigation=hockey",
          "image": "",
          "available": false
        },
        {
          "label": "Roller hockey",
          "group": "roller-hockey",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Roller-Hockey-rs-bauer-Noir-Roller-Hockey-Cabane-De-La-Glisse.png?v=1712826508&width=120",
          "available": true,
          "url": "/collections/rollers-hockey?navigation=roller-hockey"
        }
      ],
      "productQuery": "tag:\"Patins\" OR tag:\"Crosses\" OR tag:\"Protections Hockey Enfants\" OR tag:\"Accessoires hockey\" OR (tag:\"Maillots\" OR tag:\"Pantalons roller hockey\" OR tag:\"Bas hockey\") OR tag:\"Rollers hockey\"",
      "productUrl": "/search?type=product&q=tag%3A%22Patins%22+OR+tag%3A%22Crosses%22+OR+tag%3A%22Protections+Hockey+Enfants%22+OR+tag%3A%22Accessoires+hockey%22+OR+%28tag%3A%22Maillots%22+OR+tag%3A%22Pantalons+roller+hockey%22+OR+tag%3A%22Bas+hockey%22%29+OR+tag%3A%22Rollers+hockey%22&navigation=hockey",
      "url": "/search?type=product&q=tag%3A%22Patins%22+OR+tag%3A%22Crosses%22+OR+tag%3A%22Protections+Hockey+Enfants%22+OR+tag%3A%22Accessoires+hockey%22+OR+%28tag%3A%22Maillots%22+OR+tag%3A%22Pantalons+roller+hockey%22+OR+tag%3A%22Bas+hockey%22%29+OR+tag%3A%22Rollers+hockey%22&navigation=hockey"
    },
    "ice-skates": {
      "label": "Patins à glace",
      "parent": "hockey",
      "items": [
        {
          "label": "Hockey",
          "handle": "patins-hockey",
          "url": "/collections/patins-hockey?navigation=ice-skates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/patin-hockey-bauer-x-lp-intermediaire-la-cabane-de-la-glisse-hockey.jpg?v=1696079696&width=120",
          "available": true
        },
        {
          "label": "Artistique",
          "handle": "patins-artistique",
          "url": "/collections/patins-artistique?navigation=ice-skates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Patins-artistique-Fila-la-cabane-de-la-glisse.jpg?v=1700494151&width=120",
          "available": true
        },
        {
          "label": "Loisirs",
          "handle": "patins-loisirs",
          "url": "/collections/patins-loisirs?navigation=ice-skates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Patins-artistique-Fila-la-cabane-de-la-glisse.jpg?v=1700494151&width=120",
          "available": true
        },
        {
          "label": "Lacets",
          "handle": "lacets",
          "url": "/collections/lacets?navigation=ice-skates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/La-cabane-de-la-glisse-hockey-patins-lacet-cire-noir.jpg?v=1700497205&width=120",
          "available": true
        },
        {
          "label": "Protège-lames",
          "handle": "protege-lame",
          "url": "/collections/protege-lame?navigation=ice-skates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/cabanedelaglissedeckcoresl2forgedtrottinetetfreestyle_1.png?v=1700501908&width=120",
          "available": true
        },
        {
          "label": "Accessoires",
          "handle": "accessoires-patins",
          "url": "/collections/accessoires-patins?navigation=ice-skates",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/cabanedelaglissedeckcoresl2forgedtrottinetetfreestyle_1.png?v=1700501908&width=120",
          "available": true
        }
      ],
      "url": "/collections/patins?navigation=ice-skates"
    },
    "hockey-sticks": {
      "label": "Crosses de hockey",
      "parent": "hockey",
      "items": [
        {
          "label": "Crosses",
          "handle": "crosses",
          "url": "/collections/crosses?navigation=hockey-sticks",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/La-cabane-de-la-glisse-hockey-sur-glace-bauer-crosse-nexus-2022La-cabane-de-la-glisse-hockey-sur-glace-bauer-crosse-nexus-2022.jpg?v=1707394624&width=120",
          "available": true
        },
        {
          "label": "Accessoires de crosses",
          "handle": "accessoires-crosses",
          "url": "/collections/accessoires-crosses?navigation=hockey-sticks",
          "image": "",
          "available": false
        }
      ],
      "url": "/collections/crosses?navigation=hockey-sticks"
    },
    "hockey-protection": {
      "label": "Protections hockey",
      "parent": "hockey",
      "items": [
        {
          "label": "Casques",
          "handle": "casques-hockey",
          "url": "/collections/casques-hockey?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Casque-Hockey-Bauer-IMS5-noir-hockey-la-cabane-de-la-glisse.png?v=1717147413&width=120",
          "available": true
        },
        {
          "label": "Jambières",
          "handle": "jambieres-hockey",
          "url": "/collections/jambieres-hockey?navigation=hockey-protection",
          "image": "",
          "available": false
        },
        {
          "label": "Coudières",
          "handle": "coudieres-hockey",
          "url": "/collections/coudieres-hockey?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Coudiere-Bauer-x-sr-noir-bleu-hockey-la-cabane-de-la-glisse.png?v=1699698723&width=120",
          "available": true
        },
        {
          "label": "Gants",
          "handle": "gants-hockey",
          "url": "/collections/gants-hockey?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Gants-Bauer-Supreme-M3-Int-_12-13_-hockey-la-cabane-de-la-glisse.png?v=1717148697&width=120",
          "available": true
        },
        {
          "label": "Culottes & gaines",
          "handle": "culottes-gaine-hockey",
          "url": "/collections/culottes-gaine-hockey?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Culotte-Bauer-X-Sr-noir-hockey-la-cabane-de-la-glisse.png?v=1699704831&width=120",
          "available": true
        },
        {
          "label": "Épaulières & plastrons",
          "handle": "epaulieres-plastron-hockey",
          "url": "/collections/epaulieres-plastron-hockey?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/La-cabane-de-la-glisse-hockey-patins-plastron-epauliere-bauer-X-2.png?v=1700499383&width=120",
          "available": true
        },
        {
          "label": "Grilles & visières",
          "handle": "grille-visieres-accessoires-hockey",
          "url": "/collections/grille-visieres-accessoires-hockey?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/jugulaire-de-rechange-bauer-8500-5500-4500-1500.jpg?v=1788605221&width=120",
          "available": true
        },
        {
          "label": "Coquilles",
          "handle": "coquilles-hockey",
          "url": "/collections/coquilles-hockey?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Women_E2_80_99sJillPelvicProtector-la-cabane-de-la-glisse-protection-pelvienne.webp?v=1700498878&width=120",
          "available": true
        },
        {
          "label": "Protège-cou",
          "handle": "protege-cou",
          "url": "/collections/protege-cou?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/protege-clavicule-elite-bauer-hockey-la-cabane-de-la-glisse.png?v=1703003227&width=120",
          "available": true
        },
        {
          "label": "Femmes",
          "handle": "protections-femmes",
          "url": "/collections/protections-femmes?navigation=hockey-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/epauliereplastronfemmebauerlacabanedelaglisse.jpg?v=1708018506&width=120",
          "available": true
        }
      ],
      "url": "/collections/protections-hockey-protections?navigation=hockey-protection"
    },
    "hockey-accessories": {
      "label": "Accessoires hockey",
      "parent": "hockey",
      "items": [
        {
          "label": "Palets & balles",
          "handle": "palets-balles",
          "url": "/collections/palets-balles?navigation=hockey-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/hockey-palet-Reebook-Noir-Hockey-la-cabane-de-la-glisse.png?v=1699611266&width=120",
          "available": true
        },
        {
          "label": "Tapes & scotch",
          "handle": "tapes-scotch",
          "url": "/collections/tapes-scotch?navigation=hockey-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Renfrew-pro-tape-blanc-cabane-de-la-glisse.png?v=1703352729&width=120",
          "available": true
        },
        {
          "label": "Gourdes",
          "handle": "gourdes",
          "url": "/collections/gourdes?navigation=hockey-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/la-cabane-de-la-glisse-gourde-move-xl-hockey-sur-glace-bleu.png?v=1699551170&width=120",
          "available": true
        },
        {
          "label": "Visserie",
          "handle": "visseries-hockey",
          "url": "/collections/visseries-hockey?navigation=hockey-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Attache-en-plastique-pour-masque-facial-cabane-de-la-glisse.png?v=1703596739&width=120",
          "available": true
        },
        {
          "label": "Accessoires joueurs",
          "handle": "accessoires-joueurs",
          "url": "/collections/accessoires-joueurs?navigation=hockey-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/La-cabane-de-la-glisse-hockey-sur-glace-bauer.png?v=1707389294&width=120",
          "available": true
        }
      ],
      "url": "/collections/accessoires-hockey?navigation=hockey-accessories"
    },
    "hockey-clothing": {
      "label": "Textile hockey",
      "parent": "hockey",
      "items": [
        {
          "label": "Maillots",
          "handle": "maillots",
          "url": "/collections/maillots?navigation=hockey-clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Flex-Practice-Jersey-Sr-Rouge-freestyle-Cabane-de-la-Glisse_2.png?v=1707990598&width=120",
          "available": true
        },
        {
          "label": "Pantalons",
          "handle": "pantalons-roller-hockey",
          "url": "/collections/pantalons-roller-hockey?navigation=hockey-clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Pantalon-Bauer-Inline-Team-Sr-la-cabane-de-la-glisse.png?v=1703348441&width=120",
          "available": true
        },
        {
          "label": "Bas",
          "handle": "bas-hockey",
          "url": "/collections/bas-hockey?navigation=hockey-clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/hockey-chaussette-CC-Buffalo-sabres-Noir-Rouge-Gris-Blanc-Hockey-la-cabane-de-la-glisse.png?v=1699623280&width=120",
          "available": true
        },
        {
          "label": "Autres textiles",
          "handle": "autres-textiles",
          "url": "/collections/autres-textiles?navigation=hockey-clothing",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Maillots\" OR tag:\"Pantalons roller hockey\" OR tag:\"Bas hockey\"",
      "productUrl": "/search?type=product&q=tag%3A%22Maillots%22+OR+tag%3A%22Pantalons+roller+hockey%22+OR+tag%3A%22Bas+hockey%22&navigation=hockey-clothing",
      "url": "/search?type=product&q=tag%3A%22Maillots%22+OR+tag%3A%22Pantalons+roller+hockey%22+OR+tag%3A%22Bas+hockey%22&navigation=hockey-clothing"
    },
    "bmx": {
      "label": "BMX",
      "parent": "catalogue",
      "items": [
        {
          "label": "Vélos BMX",
          "group": "bmx-bikes",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Haro-Leucadia-20_-Bike-gris-BMX-freestyle-Cabane-de-la-Glisse_1.png?v=1707412193&width=120",
          "available": true,
          "url": "/collections/bmx-complet?navigation=bmx-bikes"
        },
        {
          "label": "Roues et pièces",
          "group": "bmx-wheels",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Chambre-a-Aire-BMX-Bmx-freestyle-Cabane-de-la-Glisse.png?v=1707488319&width=120",
          "available": true,
          "url": "/search?type=product&q=title%3AChambre*+AND+title%3Aair*+AND+title%3Abmx*&navigation=bmx-wheels"
        },
        {
          "label": "Pièces cadres",
          "group": "bmx-frame",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Prody-Lite-Cadre-BMX-freestyle-Cabane-de-la-Glisse.png?v=1707241940&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Cadre+Bmx%22+OR+tag%3A%22Jeu+de+direction+bmx%22&navigation=bmx-frame"
        },
        {
          "label": "Direction",
          "group": "bmx-steering",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Bloody-Oath-Guidon-BMX-chrome-BMX-freestyle-Cabane-de-la-Glisse.png?v=1707469622&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Guidons+Bmx%22+OR+tag%3A%22Fourche+Bmx%22+OR+tag%3A%22Jeu+de+direction+bmx%22&navigation=bmx-steering"
        },
        {
          "label": "Transmission",
          "group": "bmx-drive",
          "image": "",
          "available": false,
          "url": "/pages/catalogue?rubrique=bmx-drive"
        },
        {
          "label": "Grinding",
          "group": "bmx-grind",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-epic-skate-wax-teal-5060719853118-29072656892093.jpg?v=1788779273&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22groupe-core-wax%22&navigation=bmx-grind"
        },
        {
          "label": "Freins",
          "group": "bmx-brakes",
          "image": "",
          "available": false,
          "url": "/pages/catalogue?rubrique=bmx-brakes"
        },
        {
          "label": "Selles",
          "group": "bmx-seats",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Tige-De-Selle-BMX-Neochrome-Pivotal-BMX-BMX-freestyle-Cabane-de-la-Glisse.png?v=1707405831&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Pi%C3%A8ces+selle+Bmx%22+OR+%28title%3Atige*+AND+title%3Aselle*+AND+title%3Abmx*%29&navigation=bmx-seats"
        },
        {
          "label": "Protections",
          "group": "bmx-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/casque-tsg-la-cabane-de-la-glisse-noir.png?v=1777456946&width=120",
          "available": true,
          "url": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22+OR+tag%3A%22Prot%C3%A8ges+dents%22&navigation=bmx-protection"
        },
        {
          "label": "Accessoires",
          "group": "bmx-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Stand-scooter-ethic-8std-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700908936&width=120",
          "available": true,
          "url": "/search?type=product&q=%28title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22%29+OR+tag%3A%22Kendamas%22+OR+tag%3A%22Autres%22&navigation=bmx-accessories"
        },
        {
          "label": "Sacs",
          "handle": "sacs",
          "url": "/collections/sacs?navigation=bmx",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-pro-helmet-backpack.jpg?v=1787908551&width=120",
          "available": true
        }
      ],
      "url": "/collections/bmx?navigation=bmx"
    },
    "bmx-bikes": {
      "label": "Vélos BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Freestyle",
          "handle": "bmx-complet",
          "url": "/collections/bmx-complet?navigation=bmx-bikes",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Haro-Leucadia-20_-Bike-gris-BMX-freestyle-Cabane-de-la-Glisse_1.png?v=1707412193&width=120",
          "available": true
        },
        {
          "label": "Race",
          "url": "/search?type=product&q=bmx%20race&navigation=bmx-bikes",
          "image": "",
          "available": false
        },
        {
          "label": "Big wheels",
          "url": "/search?type=product&q=bmx%2024&navigation=bmx-bikes",
          "image": "",
          "available": false
        },
        {
          "label": "Dirt jump",
          "image": "",
          "available": false
        },
        {
          "label": "Mini",
          "url": "/search?type=product&q=bmx%20mini&navigation=bmx-bikes",
          "image": "",
          "available": false
        },
        {
          "label": "Enfants",
          "url": "/search?type=product&q=bmx%20enfant&navigation=bmx-bikes",
          "image": "",
          "available": false
        }
      ],
      "url": "/collections/bmx-complet?navigation=bmx-bikes"
    },
    "bmx-wheels": {
      "label": "Roues et pièces BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Roues",
          "url": "/search?type=product&q=Roues%20bmx&navigation=bmx-wheels",
          "image": "",
          "available": false
        },
        {
          "label": "Pneus",
          "url": "/search?type=product&q=Pneus%20bmx&navigation=bmx-wheels",
          "image": "",
          "available": false
        },
        {
          "label": "Chambre à air",
          "url": "/search?type=product&q=title%3AChambre*+AND+title%3Aair*+AND+title%3Abmx*&navigation=bmx-wheels",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Chambre-a-Aire-BMX-Bmx-freestyle-Cabane-de-la-Glisse.png?v=1707488319&width=120",
          "available": true,
          "legacyQuery": "Chambre à air bmx"
        },
        {
          "label": "Jantes",
          "url": "/search?type=product&q=Jantes%20bmx&navigation=bmx-wheels",
          "image": "",
          "available": false
        },
        {
          "label": "Moyeux",
          "url": "/search?type=product&q=Moyeux%20bmx&navigation=bmx-wheels",
          "image": "",
          "available": false
        },
        {
          "label": "Hub guards",
          "url": "/search?type=product&q=Hub%20guards%20bmx&navigation=bmx-wheels",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces",
          "url": "/search?type=product&q=Pi%C3%A8ces%20bmx&navigation=bmx-wheels",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "title:Chambre* AND title:air* AND title:bmx*",
      "productUrl": "/search?type=product&q=title%3AChambre*+AND+title%3Aair*+AND+title%3Abmx*&navigation=bmx-wheels",
      "url": "/search?type=product&q=title%3AChambre*+AND+title%3Aair*+AND+title%3Abmx*&navigation=bmx-wheels"
    },
    "bmx-frame": {
      "label": "Pièces cadres BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Cadres",
          "handle": "cadre-bmx",
          "url": "/collections/cadre-bmx?navigation=bmx-frame",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Prody-Lite-Cadre-BMX-freestyle-Cabane-de-la-Glisse.png?v=1707241940&width=120",
          "available": true
        },
        {
          "label": "Boîtiers de pédalier",
          "url": "/search?type=product&q=boitier%20bmx&navigation=bmx-frame",
          "image": "",
          "available": false
        },
        {
          "label": "Jeux de direction",
          "handle": "jeu-de-direction-bmx",
          "url": "/collections/jeu-de-direction-bmx?navigation=bmx-frame",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Haro-Deadset-Integrated-Jeu-De-Direction-bleu-bmx-freestyle-Cabane-de-la-Glisse.png?v=1707833754&width=120",
          "available": true
        }
      ],
      "productQuery": "tag:\"Cadre Bmx\" OR tag:\"Jeu de direction bmx\"",
      "productUrl": "/search?type=product&q=tag%3A%22Cadre+Bmx%22+OR+tag%3A%22Jeu+de+direction+bmx%22&navigation=bmx-frame",
      "url": "/search?type=product&q=tag%3A%22Cadre+Bmx%22+OR+tag%3A%22Jeu+de+direction+bmx%22&navigation=bmx-frame"
    },
    "bmx-steering": {
      "label": "Direction BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Guidons",
          "handle": "guidons-bmx",
          "url": "/collections/guidons-bmx?navigation=bmx-steering",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Bloody-Oath-Guidon-BMX-chrome-BMX-freestyle-Cabane-de-la-Glisse.png?v=1707469622&width=120",
          "available": true
        },
        {
          "label": "Potences",
          "url": "/search?type=product&q=potence%20bmx&navigation=bmx-steering",
          "image": "",
          "available": false
        },
        {
          "label": "Fourches",
          "handle": "fourche-bmx",
          "url": "/collections/fourche-bmx?navigation=bmx-steering",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Family-Fourche-BMX-BMX-freestyle-Cabane-de-la-Glisse_2.png?v=1707410702&width=120",
          "available": true
        },
        {
          "label": "Top caps",
          "url": "/search?type=product&q=top%20cap%20bmx&navigation=bmx-steering",
          "image": "",
          "available": false
        },
        {
          "label": "Jeux de direction",
          "handle": "jeu-de-direction-bmx",
          "url": "/collections/jeu-de-direction-bmx?navigation=bmx-steering",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Haro-Deadset-Integrated-Jeu-De-Direction-bleu-bmx-freestyle-Cabane-de-la-Glisse.png?v=1707833754&width=120",
          "available": true
        },
        {
          "label": "Poignées",
          "url": "/search?type=product&q=poignee%20bmx&navigation=bmx-steering",
          "image": "",
          "available": false
        },
        {
          "label": "Embouts",
          "url": "/search?type=product&q=embout%20bmx&navigation=bmx-steering",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Guidons Bmx\" OR tag:\"Fourche Bmx\" OR tag:\"Jeu de direction bmx\"",
      "productUrl": "/search?type=product&q=tag%3A%22Guidons+Bmx%22+OR+tag%3A%22Fourche+Bmx%22+OR+tag%3A%22Jeu+de+direction+bmx%22&navigation=bmx-steering",
      "url": "/search?type=product&q=tag%3A%22Guidons+Bmx%22+OR+tag%3A%22Fourche+Bmx%22+OR+tag%3A%22Jeu+de+direction+bmx%22&navigation=bmx-steering"
    },
    "bmx-drive": {
      "label": "Transmission BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Manivelles",
          "url": "/search?type=product&q=Manivelles%20bmx&navigation=bmx-drive",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces de pédalier",
          "url": "/search?type=product&q=Pi%C3%A8ces%20de%20p%C3%A9dalier%20bmx&navigation=bmx-drive",
          "image": "",
          "available": false
        },
        {
          "label": "Boîtiers de pédalier",
          "url": "/search?type=product&q=Bo%C3%AEtiers%20de%20p%C3%A9dalier%20bmx&navigation=bmx-drive",
          "image": "",
          "available": false
        },
        {
          "label": "Pédales",
          "url": "/search?type=product&q=P%C3%A9dales%20bmx&navigation=bmx-drive",
          "image": "",
          "available": false
        },
        {
          "label": "Couronnes",
          "url": "/search?type=product&q=Couronnes%20bmx&navigation=bmx-drive",
          "image": "",
          "available": false
        },
        {
          "label": "Chaînes",
          "url": "/search?type=product&q=Cha%C3%AEnes%20bmx&navigation=bmx-drive",
          "image": "",
          "available": false
        }
      ]
    },
    "bmx-grind": {
      "label": "Grinding BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Manches",
          "url": "/search?type=product&q=sleeve%20bmx&navigation=bmx-grind",
          "image": "",
          "available": false
        },
        {
          "label": "Cire",
          "handle": "groupe-core-wax",
          "url": "/collections/groupe-core-wax?navigation=bmx-grind",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-epic-skate-wax-teal-5060719853118-29072656892093.jpg?v=1788779273&width=120",
          "available": true
        },
        {
          "label": "Pegs",
          "url": "/search?type=product&q=peg%20bmx&navigation=bmx-grind",
          "image": "",
          "available": false
        },
        {
          "label": "Rampes",
          "handle": "groupe-core-rampe",
          "url": "/collections/groupe-core-rampe?navigation=bmx-grind",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"groupe-core-wax\"",
      "productUrl": "/search?type=product&q=tag%3A%22groupe-core-wax%22&navigation=bmx-grind",
      "url": "/search?type=product&q=tag%3A%22groupe-core-wax%22&navigation=bmx-grind"
    },
    "bmx-brakes": {
      "label": "Freins BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Freins",
          "url": "/search?type=product&q=frein%20bmx&navigation=bmx-brakes",
          "image": "",
          "available": false
        },
        {
          "label": "Leviers",
          "url": "/search?type=product&q=levier%20bmx&navigation=bmx-brakes",
          "image": "",
          "available": false
        },
        {
          "label": "Pièces",
          "url": "/search?type=product&q=frein%20bmx&navigation=bmx-brakes",
          "image": "",
          "available": false
        }
      ]
    },
    "bmx-seats": {
      "label": "Selles BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Selles",
          "handle": "pieces-selle-bmx",
          "url": "/collections/pieces-selle-bmx?navigation=bmx-seats",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Tige-De-Selle-BMX-Neochrome-Pivotal-BMX-BMX-freestyle-Cabane-de-la-Glisse.png?v=1707405831&width=120",
          "available": true
        },
        {
          "label": "Colliers de selle",
          "url": "/search?type=product&q=collier%20selle%20bmx&navigation=bmx-seats",
          "image": "",
          "available": false
        },
        {
          "label": "Tiges de selle",
          "url": "/search?type=product&q=title%3Atige*+AND+title%3Aselle*+AND+title%3Abmx*&navigation=bmx-seats",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Colony-Tige-De-Selle-BMX-Neochrome-Pivotal-BMX-BMX-freestyle-Cabane-de-la-Glisse.png?v=1707405831&width=120",
          "available": true,
          "legacyQuery": "tige selle bmx"
        }
      ],
      "productQuery": "tag:\"Pièces selle Bmx\" OR (title:tige* AND title:selle* AND title:bmx*)",
      "productUrl": "/search?type=product&q=tag%3A%22Pi%C3%A8ces+selle+Bmx%22+OR+%28title%3Atige*+AND+title%3Aselle*+AND+title%3Abmx*%29&navigation=bmx-seats",
      "url": "/search?type=product&q=tag%3A%22Pi%C3%A8ces+selle+Bmx%22+OR+%28title%3Atige*+AND+title%3Aselle*+AND+title%3Abmx*%29&navigation=bmx-seats"
    },
    "bmx-accessories": {
      "label": "Accessoires BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Entretien",
          "url": "/search?type=product&q=outil%20bmx&navigation=bmx-accessories",
          "image": "",
          "available": false
        },
        {
          "label": "Goodies",
          "group": "goodies",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/KROM_POP_PINK-04-la-cabane-de-la-glisse-krom-kendamas-5.webp?v=1702054616&width=120",
          "available": true,
          "url": "/search?type=product&q=title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22&navigation=goodies"
        },
        {
          "label": "Antivols",
          "image": "",
          "available": false
        },
        {
          "label": "Kendama",
          "handle": "kendamas",
          "url": "/collections/kendamas?navigation=bmx-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/KROM_POP_PINK-04-la-cabane-de-la-glisse-krom-kendamas-5.webp?v=1702054616&width=120",
          "available": true
        },
        {
          "label": "Divers",
          "handle": "autres-1",
          "url": "/collections/autres-1?navigation=bmx-accessories",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Stand-scooter-ethic-8std-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700908936&width=120",
          "available": true
        }
      ],
      "productQuery": "(title:autocollant* OR tag:\"Accessoires\" OR tag:\"Kendamas\") OR tag:\"Kendamas\" OR tag:\"Autres\"",
      "productUrl": "/search?type=product&q=%28title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22%29+OR+tag%3A%22Kendamas%22+OR+tag%3A%22Autres%22&navigation=bmx-accessories",
      "url": "/search?type=product&q=%28title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22%29+OR+tag%3A%22Kendamas%22+OR+tag%3A%22Autres%22&navigation=bmx-accessories"
    },
    "protection": {
      "label": "Protections",
      "parent": "catalogue",
      "items": [
        {
          "label": "Protège-dents",
          "handle": "proteges-dents",
          "url": "/collections/proteges-dents?navigation=protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/proteges-dents-core-noir-protections-trottinette-freestyle-Cabane-De-La-Glisse.png?v=1714143690&width=120",
          "available": true
        },
        {
          "label": "Casques",
          "handle": "casques",
          "url": "/collections/casques?navigation=protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/casque-tsg-la-cabane-de-la-glisse-noir.png?v=1777456946&width=120",
          "available": true
        },
        {
          "label": "Enfants",
          "group": "protection-kids",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true,
          "url": "/collections/protections-enfant?navigation=protection-kids"
        },
        {
          "label": "Gants",
          "url": "/search?type=product&q=gants%20protection&navigation=protection",
          "image": "",
          "available": false
        },
        {
          "label": "Kit de protections",
          "handle": "packs-protections",
          "url": "/collections/packs-protections?navigation=protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true
        },
        {
          "label": "Genouillères",
          "handle": "genouilleres",
          "url": "/collections/genouilleres?navigation=protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Protection-genouillere-Core-Pro-park-trottinette-skateboard-freestyle-Cabane-De-La-Glisse.png?v=1713371363&width=120",
          "available": true
        },
        {
          "label": "Coudières",
          "handle": "coudieres",
          "url": "/collections/coudieres?navigation=protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Pack-genouillere-coudiere-187-killer-pads-x-Independent-noir-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700835185&width=120",
          "available": true
        },
        {
          "label": "Shorts de protection",
          "handle": "shorts",
          "url": "/collections/shorts?navigation=protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/CORE-Impact-Stealth-Short-protection-trottinette-freestyle-cabane-de-la-glisse.png?v=1703760807&width=120",
          "available": true
        },
        {
          "label": "Tibia & cheville",
          "group": "protection-lower",
          "image": "",
          "available": false,
          "url": "/pages/catalogue?rubrique=protection-lower"
        }
      ],
      "url": "/collections/protections?navigation=protection"
    },
    "protection-kids": {
      "label": "Protections enfant",
      "parent": "protection",
      "items": [
        {
          "label": "Casques",
          "handle": "casques-enfant",
          "url": "/collections/casques-enfant?navigation=protection-kids",
          "image": "",
          "available": false
        },
        {
          "label": "Kit de protections",
          "handle": "packs-protections-enfant",
          "url": "/collections/packs-protections-enfant?navigation=protection-kids",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true
        }
      ],
      "url": "/collections/protections-enfant?navigation=protection-kids"
    },
    "protection-lower": {
      "label": "Tibia & cheville",
      "parent": "protection",
      "items": [
        {
          "label": "Protège-tibias",
          "handle": "proteges-tibias",
          "url": "/collections/proteges-tibias?navigation=protection-lower",
          "image": "",
          "available": false
        },
        {
          "label": "Chevillères",
          "handle": "chevilleres",
          "url": "/collections/chevilleres?navigation=protection-lower",
          "image": "",
          "available": false
        }
      ]
    },
    "lifestyle": {
      "label": "Lifestyle",
      "parent": "catalogue",
      "items": [
        {
          "label": "Vêtements",
          "group": "clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/T-shirtETHICDTCCasualsuspectNoirTrottinettefreestyleCabanedelaglisse..png?v=1691421508&width=120",
          "available": true,
          "url": "/collections/vetements?navigation=clothing"
        },
        {
          "label": "Heelys",
          "handle": "heelys-chaussure-a-roulette",
          "url": "/collections/heelys-chaussure-a-roulette?navigation=lifestyle",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Heelys-pro20-noir-heelys-Cabane-De-La-Glisse.png?v=1713359545&width=120",
          "available": true
        },
        {
          "label": "Sacs",
          "handle": "sacs",
          "url": "/collections/sacs?navigation=lifestyle",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/core-pro-helmet-backpack.jpg?v=1787908551&width=120",
          "available": true
        },
        {
          "label": "Fingerskates",
          "handle": "fingerskates",
          "url": "/collections/fingerskates?navigation=lifestyle",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Format_Completes_FINGER_SCOOTERS_AOSV6_BK__94650.jpg?v=1779287620&width=120",
          "available": true
        },
        {
          "label": "Kendamas",
          "handle": "kendamas",
          "url": "/collections/kendamas?navigation=lifestyle",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/KROM_POP_PINK-04-la-cabane-de-la-glisse-krom-kendamas-5.webp?v=1702054616&width=120",
          "available": true
        },
        {
          "label": "Goodies",
          "group": "goodies",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Stand-scooter-ethic-8std-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700908936&width=120",
          "available": true,
          "url": "/search?type=product&q=title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22&navigation=goodies"
        },
        {
          "label": "Balance boards",
          "handle": "balance-boards",
          "url": "/collections/balance-boards?navigation=lifestyle",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"vetements\" OR tag:\"Heelys Chaussure à Roulette\" OR tag:\"Sacs\" OR tag:\"Fingerskates\" OR tag:\"Kendamas\" OR (title:autocollant* OR tag:\"Accessoires\" OR tag:\"Kendamas\")",
      "productUrl": "/search?type=product&q=tag%3A%22vetements%22+OR+tag%3A%22Heelys+Chaussure+%C3%A0+Roulette%22+OR+tag%3A%22Sacs%22+OR+tag%3A%22Fingerskates%22+OR+tag%3A%22Kendamas%22+OR+%28title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22%29&navigation=lifestyle",
      "url": "/search?type=product&q=tag%3A%22vetements%22+OR+tag%3A%22Heelys+Chaussure+%C3%A0+Roulette%22+OR+tag%3A%22Sacs%22+OR+tag%3A%22Fingerskates%22+OR+tag%3A%22Kendamas%22+OR+%28title%3Aautocollant*+OR+tag%3A%22Accessoires%22+OR+tag%3A%22Kendamas%22%29&navigation=lifestyle"
    },
    "clothing": {
      "label": "Vêtements",
      "parent": "lifestyle",
      "items": [
        {
          "label": "Tous les vêtements",
          "handle": "vetements",
          "url": "/collections/vetements?navigation=clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/T-shirtETHICDTCCasualsuspectNoirTrottinettefreestyleCabanedelaglisse..png?v=1691421508&width=120",
          "available": true
        },
        {
          "label": "T-shirts",
          "url": "/search?type=product&q=title%3At-shirt*&navigation=clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Both_5.jpg?v=1788779557&width=120",
          "available": true,
          "legacyQuery": "t-shirt"
        },
        {
          "label": "Sweats",
          "url": "/search?type=product&q=title%3Asweat*&navigation=clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/OrangeDrop_Hoodies_Details_88cc021c-a073-4de9-9889-3f3788d0505e.jpg?v=1712327321&width=120",
          "available": true,
          "legacyQuery": "sweat"
        },
        {
          "label": "Casquettes",
          "url": "/search?type=product&q=title%3Acasquette*&navigation=clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/CapsEmotions-Produit.jpg?v=1712327093&width=120",
          "available": true,
          "legacyQuery": "casquette"
        },
        {
          "label": "Bonnets",
          "url": "/search?type=product&q=bonnet&navigation=clothing",
          "image": "",
          "available": false
        },
        {
          "label": "Chaussettes",
          "url": "/search?type=product&q=title%3Achaussette*&navigation=clothing",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/hockey-chaussette-Tilburg-Bleu-Jaune-Hockey-la-cabane-de-la-glisse.png?v=1699622616&width=120",
          "available": true,
          "legacyQuery": "chaussette"
        }
      ],
      "url": "/collections/vetements?navigation=clothing"
    },
    "roller-hockey-parts": {
      "label": "Pièces de roller hockey",
      "parent": "roller-hockey",
      "items": [
        {
          "label": "Roues",
          "handle": "roues-rollers",
          "url": "/collections/roues-rollers?navigation=roller-hockey-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Nano-wheel-blanche-F-series-freestyle-la-cabane-de-la-glisse.png?v=1703262834&width=120",
          "available": true
        },
        {
          "label": "Roulements",
          "handle": "roulements-2",
          "url": "/collections/roulements-2?navigation=roller-hockey-parts",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/blunt-roulement-abec9-x1-la-cabane-de-la-glisse-trottinette-freestyle-scooter.webp?v=1687020878&width=120",
          "available": true
        },
        {
          "label": "Entretien",
          "handle": "accessoires-rollers",
          "url": "/collections/accessoires-rollers?navigation=roller-hockey-parts",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Roues rollers\" OR tag:\"Roulements\"",
      "productUrl": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22&navigation=roller-hockey-parts",
      "url": "/search?type=product&q=tag%3A%22Roues+rollers%22+OR+tag%3A%22Roulements%22&navigation=roller-hockey-parts"
    },
    "skate-protection": {
      "label": "Protections skateboard",
      "parent": "skate",
      "items": [
        {
          "label": "Enfants",
          "group": "protection-kids",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true,
          "url": "/collections/protections-enfant?navigation=protection-kids"
        },
        {
          "label": "Casques",
          "handle": "casques",
          "url": "/collections/casques?navigation=skate-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/casque-tsg-la-cabane-de-la-glisse-noir.png?v=1777456946&width=120",
          "available": true
        },
        {
          "label": "Kit de protections",
          "handle": "packs-protections",
          "url": "/collections/packs-protections?navigation=skate-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true
        },
        {
          "label": "Genouillères",
          "handle": "genouilleres",
          "url": "/collections/genouilleres?navigation=skate-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Protection-genouillere-Core-Pro-park-trottinette-skateboard-freestyle-Cabane-De-La-Glisse.png?v=1713371363&width=120",
          "available": true
        },
        {
          "label": "Protège-poignets",
          "handle": "proteges-poignets",
          "url": "/collections/proteges-poignets?navigation=skate-protection",
          "image": "",
          "available": false
        },
        {
          "label": "Coudières",
          "handle": "coudieres",
          "url": "/collections/coudieres?navigation=skate-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Pack-genouillere-coudiere-187-killer-pads-x-Independent-noir-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700835185&width=120",
          "available": true
        },
        {
          "label": "Shorts de protection",
          "handle": "shorts",
          "url": "/collections/shorts?navigation=skate-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/CORE-Impact-Stealth-Short-protection-trottinette-freestyle-cabane-de-la-glisse.png?v=1703760807&width=120",
          "available": true
        },
        {
          "label": "Gants longboard",
          "image": "",
          "available": false
        }
      ],
      "productQuery": "tag:\"Protections enfant\" OR tag:\"Casques\" OR tag:\"Packs protections\" OR tag:\"Genouillères\" OR tag:\"Coudières\" OR tag:\"Shorts\"",
      "productUrl": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22&navigation=skate-protection",
      "url": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Packs+protections%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22&navigation=skate-protection"
    },
    "bmx-protection": {
      "label": "Protections BMX",
      "parent": "bmx",
      "items": [
        {
          "label": "Enfants",
          "group": "protection-kids",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Kit-de-protection-la-cabane-de-la-glisse-tony-hawk-kit-de-protection-casque-genouillere-coudiere.png?v=1694860437&width=120",
          "available": true,
          "url": "/collections/protections-enfant?navigation=protection-kids"
        },
        {
          "label": "Casques",
          "handle": "casques",
          "url": "/collections/casques?navigation=bmx-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/casque-tsg-la-cabane-de-la-glisse-noir.png?v=1777456946&width=120",
          "available": true
        },
        {
          "label": "Gants",
          "url": "/search?type=product&q=gants%20protection&navigation=bmx-protection",
          "image": "",
          "available": false
        },
        {
          "label": "Genouillères",
          "handle": "genouilleres",
          "url": "/collections/genouilleres?navigation=bmx-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Protection-genouillere-Core-Pro-park-trottinette-skateboard-freestyle-Cabane-De-La-Glisse.png?v=1713371363&width=120",
          "available": true
        },
        {
          "label": "Coudières",
          "handle": "coudieres",
          "url": "/collections/coudieres?navigation=bmx-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/Pack-genouillere-coudiere-187-killer-pads-x-Independent-noir-trottinette-freestyle-la-cabane-de-la-glisse.png?v=1700835185&width=120",
          "available": true
        },
        {
          "label": "Shorts de protection",
          "handle": "shorts",
          "url": "/collections/shorts?navigation=bmx-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/CORE-Impact-Stealth-Short-protection-trottinette-freestyle-cabane-de-la-glisse.png?v=1703760807&width=120",
          "available": true
        },
        {
          "label": "Protège-dents",
          "handle": "proteges-dents",
          "url": "/collections/proteges-dents?navigation=bmx-protection",
          "image": "https://cdn.shopify.com/s/files/1/0754/0595/1305/files/proteges-dents-core-noir-protections-trottinette-freestyle-Cabane-De-La-Glisse.png?v=1714143690&width=120",
          "available": true
        },
        {
          "label": "Tibia & cheville",
          "group": "protection-lower",
          "image": "",
          "available": false,
          "url": "/pages/catalogue?rubrique=protection-lower"
        }
      ],
      "productQuery": "tag:\"Protections enfant\" OR tag:\"Casques\" OR tag:\"Genouillères\" OR tag:\"Coudières\" OR tag:\"Shorts\" OR tag:\"Protèges dents\"",
      "productUrl": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22+OR+tag%3A%22Prot%C3%A8ges+dents%22&navigation=bmx-protection",
      "url": "/search?type=product&q=tag%3A%22Protections+enfant%22+OR+tag%3A%22Casques%22+OR+tag%3A%22Genouill%C3%A8res%22+OR+tag%3A%22Coudi%C3%A8res%22+OR+tag%3A%22Shorts%22+OR+tag%3A%22Prot%C3%A8ges+dents%22&navigation=bmx-protection"
    }
  },
  "mapping": {
    "all": "catalogue",
    "promotions": "catalogue",
    "best-seller": "catalogue",
    "trottinettes-freestyles-completes": "scooter",
    "trottinettes-trampoline": "scooter",
    "promotions-trottinettes": "scooter",
    "pieces-detachees-trottinettes-freestyle": "scooter-parts",
    "decks": "scooter-parts",
    "bars-guidons": "scooter-parts",
    "poignees": "scooter-parts",
    "grips-trottinettes": "scooter-parts",
    "fourches": "scooter-parts",
    "jeux-de-direction": "scooter-parts",
    "colliers-de-serrages": "scooter-parts",
    "freins": "scooter-parts",
    "roues-trottinettes": "scooter-parts",
    "roulements": "scooter-parts",
    "visseries": "scooter-parts",
    "autres-pieces-trottinettes": "scooter-parts",
    "pieces-doccasion": "scooter-parts",
    "groupe-core-foldy-3-roues": "scooter-kids",
    "accessoires": "goodies",
    "promotions-skateboard": "skate",
    "skateboards-complets": "skateboards",
    "planches": "skateboards",
    "trucks": "skateboards",
    "roues": "skateboards",
    "grip-skateboard": "skateboards",
    "accessoires-skateboard": "skateboards",
    "visseries-skateboard": "skate-parts",
    "roulements-1": "skate-parts",
    "pads": "skate-parts",
    "outils-skateboard": "skate-parts",
    "autres-pieces-detachees": "skate-parts",
    "longboard": "longboards",
    "cruiser-surfskate": "cruisers",
    "promotions-rollers": "roller",
    "rollers-en-ligne": "roller-inline",
    "rollers-enfant": "roller-inline",
    "rollers-balade-fitness": "roller-inline",
    "rollers-balade-1": "roller-inline",
    "pieces-detachees-rollers": "roller-parts",
    "roues-rollers": "roller-parts",
    "roulements-2": "roller-parts",
    "visseries-rollers": "roller-parts",
    "pieces-de-roues": "roller-parts",
    "autres-pieces-rollers": "roller-parts",
    "accessoires-rollers": "roller-parts",
    "rollers-quad": "roller-quad",
    "rollers-derby": "roller-quad",
    "rollers-freestyle-agressif": "roller-aggressive",
    "rollers-3-roues": "roller-freeskate",
    "rollers-vitesse-course": "roller-speed",
    "rollers-hockey": "roller-hockey",
    "rollers-hockey-1": "roller-hockey",
    "protections-rollers": "roller-protection",
    "casques-rollers": "roller-protection",
    "genouilleres-rollers": "roller-protection",
    "promotions-hockey-patin": "hockey",
    "loisirs": "hockey",
    "patins": "ice-skates",
    "patins-hockey": "ice-skates",
    "patins-artistique": "ice-skates",
    "patins-loisirs": "ice-skates",
    "lacets": "ice-skates",
    "lacets-1": "ice-skates",
    "protege-lame": "ice-skates",
    "accessoires-patins": "ice-skates",
    "crosses": "hockey-sticks",
    "accessoires-crosses": "hockey-sticks",
    "protections-hockey-protections": "hockey-protection",
    "protections-joueurs": "hockey-protection",
    "casques-hockey": "hockey-protection",
    "jambieres-hockey": "hockey-protection",
    "coudieres-hockey": "hockey-protection",
    "gants-hockey": "hockey-protection",
    "gants-hockey-1": "hockey-protection",
    "culottes-gaine-hockey": "hockey-protection",
    "epaulieres-plastron-hockey": "hockey-protection",
    "grille-visieres-accessoires-hockey": "hockey-protection",
    "coquilles-hockey": "hockey-protection",
    "protege-cou": "hockey-protection",
    "protections-femmes": "hockey-protection",
    "accessoires-hockey": "hockey-accessories",
    "palets-balles": "hockey-accessories",
    "palets-balles-1": "hockey-accessories",
    "tapes-scotch": "hockey-accessories",
    "gourdes": "hockey-accessories",
    "gourdes-1": "hockey-accessories",
    "visseries-hockey": "hockey-accessories",
    "accessoires-joueurs": "hockey-accessories",
    "textiles": "hockey-clothing",
    "maillots": "hockey-clothing",
    "pantalons-roller-hockey": "hockey-clothing",
    "bas-hockey": "hockey-clothing",
    "autres-textiles": "hockey-clothing",
    "bmx": "bmx",
    "bmx-complet": "bmx-bikes",
    "cadre-bmx": "bmx-frame",
    "jeu-de-direction-bmx": "bmx-frame",
    "guidons-bmx": "bmx-steering",
    "fourche-bmx": "bmx-steering",
    "pieces-selle-bmx": "bmx-seats",
    "autres-1": "bmx-accessories",
    "protections": "protection",
    "protections-adulte": "protection",
    "promotions-protections": "protection",
    "casques": "protection",
    "genouilleres": "protection",
    "coudieres": "protection",
    "coudieres-1": "protection",
    "packs-protections": "protection",
    "proteges-dents": "protection",
    "proteges-poignets": "protection",
    "shorts": "protection",
    "autres-protections-adulte": "protection",
    "protections-enfant": "protection-kids",
    "casques-enfant": "protection-kids",
    "packs-protections-enfant": "protection-kids",
    "genouilleres-enfant": "protection-kids",
    "shorts-enfant": "protection-kids",
    "proteges-tibias": "protection-lower",
    "chevilleres": "protection-lower",
    "heelys-chaussure-a-roulette": "lifestyle",
    "sacs": "lifestyle",
    "fingerskates": "lifestyle",
    "kendamas": "lifestyle",
    "balance-boards": "lifestyle",
    "autres": "lifestyle",
    "vetements": "clothing",
    "vetements-1": "clothing",
    "streetwear": "clothing",
    "groupe-core-t-shirt-hollow-icon": "clothing",
    "carte-cadeau": "catalogue",
    "comment-bien-choisir-la-taille-de-sa-trottinette-freestyle": "scooter",
    "comment-monter-sa-trottinette-freestyle": "scooter",
    "gardien": "hockey",
    "groupe-blunt-colt-s5": "scooter",
    "groupe-blunt-colt-s6": "scooter",
    "groupe-blunt-one-s3": "scooter",
    "groupe-blunt-prodigy-s9": "scooter",
    "groupe-blunt-prodigy-serie-x": "scooter",
    "groupe-blunt-prodigy-x-one": "scooter",
    "groupe-blunt-x-one-street": "scooter",
    "groupe-core-ca1": "scooter",
    "groupe-core-cb1": "scooter",
    "groupe-core-cb1-mini": "scooter",
    "groupe-core-cd1": "scooter",
    "groupe-core-cg1": "scooter",
    "groupe-core-cg1-mini": "scooter",
    "groupe-core-cl1": "scooter",
    "groupe-core-collier-aura": "scooter-parts",
    "groupe-core-deck-cd1": "scooter-parts",
    "groupe-core-deck-cl1": "scooter-parts",
    "groupe-core-deck-sl1": "scooter-parts",
    "groupe-core-deck-st1": "scooter-parts",
    "groupe-core-deck-st3": "scooter-parts",
    "groupe-core-foldy": "scooter",
    "groupe-core-rampe": "goodies",
    "groupe-core-sl3": "scooter",
    "groupe-core-sl3-mini": "scooter",
    "groupe-core-st3": "scooter",
    "groupe-core-stand": "goodies",
    "groupe-core-wax": "goodies",
    "groupe-drone-shadow": "scooter",
    "groupe-ethic-erawan-v2": "scooter",
    "groupe-ethic-pandora": "scooter",
    "groupe-fuzion-z350": "scooter",
    "groupe-invert-curbside": "scooter",
    "groupe-native-format": "scooter",
    "groupe-native-stem": "scooter",
    "groupe-striker-gravis": "scooter",
    "groupe-urbanartt-bone": "scooter",
    "groupe-versatyl-bloody-mary": "scooter",
    "groupe-versatyl-cosmopolitan": "scooter",
    "guide-hockey": "hockey",
    "guide-roller": "roller",
    "guide-skateboard": "catalogue",
    "guide-trottinette-freestyle": "scooter",
    "platines": "roller",
    "qui-sommes-nous": "catalogue",
    "visseries-1": "skate-parts"
  }
};
